import { prodEnvironment } from '@/env/env';
import mapboxgl from 'mapbox-gl'
import { actionSheetController, alertController } from '@ionic/vue';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Geolocation } from '@capacitor/geolocation';
import { Dialog } from '@capacitor/dialog';
import * as turf from '@turf/turf'
import proj4 from 'proj4';
import { ref } from 'vue';
import { Preferences } from '@capacitor/preferences';
import { Device } from '@capacitor/device';
import { RulerControl } from 'mapbox-gl-controls';
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import datagouv from '../assets/json/datagouv.json';
import ExcelJS from "exceljs";


// import imagePath from '@/assets/img/profile-placeholder.png';


// const imageMarker = new Image();
// imageMarker.src = imagePath;

import {
    showAnnotations,
    showAppuis,
    showBD2, showCadastre, showCD2,
    showLogements,
    // showLogements 
} from '@/services/user.services';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { chambresEnvirons, choixDeCapacite, choixDeConduite, downloadBlob, fciCommande, ingenierieCapacitePourPose, isOpenArrangePath, isOpenRapportBlo, listeRemarques, nomCommande, snapConduite, tableauCable, tableauCommande } from '@/services/path.services';
import { point, nearestPoint } from '@turf/turf';
import { normalizeAppuiId } from '@/services/prep-troncon.services';


export const input = ref('');

type etude = { etude: string, societe: string, insee: string };

export type EtudeNroGroupe = {
    etude: string;
    societe: string;
    /** Optionnel : enrichissement ARCEP mediapost (deduit cote serveur si absent). */
    insee: string;
};

export const listeNRO = ref<EtudeNroGroupe[]>([]);

function groupEtudesParNro(rows: etude[]): EtudeNroGroupe[] {
    const byEtude = new Map<string, EtudeNroGroupe>();
    for (const row of rows) {
        const name = (row.etude || "").trim();
        if (!name) continue;
        const insee = (row.insee || "").trim();
        const existing = byEtude.get(name);
        if (!existing) {
            byEtude.set(name, {
                etude: name,
                societe: (row.societe || "").trim(),
                insee,
            });
            continue;
        }
        if (!existing.societe && row.societe) {
            existing.societe = (row.societe || "").trim();
        }
        if (!existing.insee && insee) {
            existing.insee = insee;
        }
    }
    return Array.from(byEtude.values()).sort((a, b) =>
        a.etude.localeCompare(b.etude, "fr")
    );
}

export const infoDevice = await Device.getInfo();

export const eventsMapboxConduite = ref(false);
export const eventsMapboxChambre = ref(false);
export const eventsMapboxAppui = ref(false);

export const activeBpe = ref(false);
export const activeLog = ref(false);

export const fciHandle = ref("F00000jjmmaa");

export let annotations_arcep: any;
export let annotations_conduites: any;
export let annotations_bloquants: any;
export let annotations_chambres: any;
export let annotations_appuis: any;
export let annotations_edf: any;


export const dessinEnCours = ref(false);
export const selectionCouche = ref('chambres')
export const isMapReady = ref(false);


export const searchArea = ref(null)
export let promptInUse = false;

let midpoint: [number, number];


interface FeatureS {
    type: string;
    DEPART: string;
    ARRIVEE: string;
    properties: {
        id: string;
        label: string;
        CODE_CH1: string;
        NUM_APPUI: string;
        STATUT: string;
        MODE_POSE: string;
        AUT_PASSAG: string;
        AUT_PASS_1: string;
        NATURE_CON: string;
        TYPE_LONGU: string;
        LONGUEUR: string;
        COMPOSITIO: string;
        ID_PROPRIE: string;
        ORIGINE: string;
        CLASSE: string;
        SHAPE_LEN: string;
        insee: string;
        ANNOTATION: string;
        type: string
    },
    geometry: {
        type: string;
        coordinates: any[];
    }
}

export let drawnLine: FeatureS | null = null; // Variable to store the drawn line feature
type AnnexeC6DraftLine = {
    id: string;
    createdAt: string;
    cable: string;
    color: string;
    feature: any;
};
const annexeC6DraftLines: AnnexeC6DraftLine[] = [];
const ANNEXE_C6_DRAFT_SOURCE = "annexe-c6-drafts-preview";
const ANNEXE_C6_DRAFT_LINE_LAYER = "annexe-c6-drafts-preview-line";
const ANNEXE_C6_DRAFT_NODE_LAYER = "annexe-c6-drafts-preview-nodes";
const ANNEXE_C6_DRAFT_OVERLAY_ID = "annexe-c6-drafts-overlay";
const ANNEXE_C6_COLORS = ["#f59e0b", "#22c55e", "#3b82f6", "#a855f7", "#ef4444", "#06b6d4"];
const ANNEXE_C6_STANDARD_CABLES = new Set([
    "98-8-4",
    "98-14-4",
    "98-28-4",
    "98-56-4",
    "98-112-4",
]);

function annexeC6NappeForCable(cable: string): string {
    return ANNEXE_C6_STANDARD_CABLES.has(cable) ? "Standard" : "Haute";
}

function annexeC6CableBold(cable: string): boolean {
    return !ANNEXE_C6_STANDARD_CABLES.has(cable);
}

type AnnexeC6Ligne = {
    depart: string;
    arrivee: string;
    cable: string;
    longueur: number;
    angle: number;
    nappe: string;
};

function sortAnnexeC6LiensPourAppui(a: AnnexeC6Ligne, b: AnnexeC6Ligne): number {
    const af = annexeC6CableBold(a.cable) ? 0 : 1;
    const bf = annexeC6CableBold(b.cable) ? 0 : 1;
    if (af !== bf) return af - bf;
    return String(a.arrivee).localeCompare(String(b.arrivee), "fr");
}

function bumpAnnexeC6LabelIndices(
    labelIndex: Map<string, number>,
    fromIndex: number,
    delta: number,
): void {
    if (!delta) return;
    for (const [key, idx] of labelIndex) {
        if (idx >= fromIndex) labelIndex.set(key, idx + delta);
    }
}

function mergeAnnexeC6PathIntoOrder(
    ordered: string[],
    labelIndex: Map<string, number>,
    path: readonly string[],
): void {
    const labels: string[] = [];
    const norms: string[] = [];
    for (const appuiNum of path) {
        const label = String(appuiNum || "").trim();
        if (!label) continue;
        labels.push(label);
        norms.push(normalizeAppuiId(label));
    }
    if (!labels.length) return;

    let firstExistingAt = -1;
    for (let i = 0; i < norms.length; i++) {
        if (labelIndex.has(norms[i])) {
            firstExistingAt = i;
            break;
        }
    }

    if (firstExistingAt === -1) {
        for (let i = 0; i < labels.length; i++) {
            if (labelIndex.has(norms[i])) continue;
            labelIndex.set(norms[i], ordered.length);
            ordered.push(labels[i]);
        }
        return;
    }

    const anchorNorm = norms[firstExistingAt];
    const anchorIdxFound = labelIndex.get(anchorNorm);
    if (anchorIdxFound === undefined) return;
    let anchorIdx = anchorIdxFound;

    const prefixLabels: string[] = [];
    for (let i = 0; i < firstExistingAt; i++) {
        if (!labelIndex.has(norms[i])) prefixLabels.push(labels[i]);
    }

    const suffixLabels: string[] = [];
    for (let i = firstExistingAt + 1; i < labels.length; i++) {
        if (!labelIndex.has(norms[i])) suffixLabels.push(labels[i]);
    }

    if (prefixLabels.length) {
        ordered.splice(anchorIdx, 0, ...prefixLabels);
        bumpAnnexeC6LabelIndices(labelIndex, anchorIdx, prefixLabels.length);
        for (let i = 0; i < prefixLabels.length; i++) {
            labelIndex.set(normalizeAppuiId(prefixLabels[i]), anchorIdx + i);
        }
        anchorIdx += prefixLabels.length;
    }

    for (const lbl of suffixLabels) {
        const norm = normalizeAppuiId(lbl);
        if (labelIndex.has(norm)) continue;
        ordered.splice(anchorIdx + 1, 0, lbl);
        bumpAnnexeC6LabelIndices(labelIndex, anchorIdx + 1, 1);
        labelIndex.set(norm, anchorIdx + 1);
        anchorIdx += 1;
    }
}

function orderAnnexeC6AppuisAlongPaths(pathSequences: readonly string[][]): string[] {
    const ordered: string[] = [];
    const labelIndex = new Map<string, number>();
    for (const path of pathSequences) {
        mergeAnnexeC6PathIntoOrder(ordered, labelIndex, path);
    }
    return ordered;
}

function snapLineFeatureToAppuis(lineFeature: any): { appuiNums: string[]; listeAppuis: any[] } {
    const multiLineString = convertToMultiLineString(lineFeature);
    const appuiNums: string[] = [];
    const listeAppuis: any[] = [];
    multiLineString.geometry.coordinates[0].forEach((coorSet: any) => {
        const point1 = point(coorSet);
        const nearest = nearestPoint(point1, appuisActif);
        const num = String(nearest?.properties?.NUM_APPUI || "").trim();
        if (!num) return;
        if (appuiNums.length && normalizeAppuiId(appuiNums[appuiNums.length - 1]) === normalizeAppuiId(num)) {
            return;
        }
        appuiNums.push(num);
        listeAppuis.push(nearest);
    });
    return { appuiNums, listeAppuis };
}

// Force string data when Filesystem.readFile may return string | Blob
const toStringData = async (data: string | Blob): Promise<string> => {
    if (typeof data === 'string') return data;
    return await data.text();
}


export const folderCapacitor = ref(Directory.Documents);
const isAndroid11 = ref(false);
const device = await Device.getInfo();
if (device.platform === 'android') {
    folderCapacitor.value = Directory.External
    isAndroid11.value = true;
}

const ANNEXE_DRAW_STYLES: any[] = [
    {
        id: 'gl-draw-polygon-fill',
        type: 'fill',
        filter: ['all', ['==', '$type', 'Polygon']],
        paint: {
            'fill-color': ['case', ['==', ['get', 'active'], 'true'], '#f59e0b', '#3bb2d0'],
            'fill-opacity': 0.12,
        },
    },
    {
        id: 'gl-draw-lines',
        type: 'line',
        filter: ['any', ['==', '$type', 'LineString'], ['==', '$type', 'Polygon']],
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: {
            'line-color': ['case', ['==', ['get', 'active'], 'true'], '#f59e0b', '#2563eb'],
            'line-dasharray': ['case', ['==', ['get', 'active'], 'true'], ['literal', [0.2, 2]], ['literal', [2, 0]]],
            'line-width': 5,
            'line-opacity': 0.95,
        },
    },
    {
        id: 'gl-draw-point-outer',
        type: 'circle',
        filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'feature']],
        paint: {
            'circle-radius': ['case', ['==', ['get', 'active'], 'true'], 8, 6],
            'circle-color': '#ffffff',
        },
    },
    {
        id: 'gl-draw-point-inner',
        type: 'circle',
        filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'feature']],
        paint: {
            'circle-radius': ['case', ['==', ['get', 'active'], 'true'], 6, 4],
            'circle-color': ['case', ['==', ['get', 'active'], 'true'], '#f59e0b', '#2563eb'],
        },
    },
    {
        id: 'gl-draw-vertex-outer',
        type: 'circle',
        filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'vertex'], ['!=', 'mode', 'simple_select']],
        paint: {
            'circle-radius': ['case', ['==', ['get', 'active'], 'true'], 8, 6],
            'circle-color': '#ffffff',
        },
    },
    {
        id: 'gl-draw-vertex-inner',
        type: 'circle',
        filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'vertex'], ['!=', 'mode', 'simple_select']],
        paint: {
            'circle-radius': ['case', ['==', ['get', 'active'], 'true'], 6, 4],
            'circle-color': '#f59e0b',
        },
    },
    {
        id: 'gl-draw-midpoint',
        type: 'circle',
        filter: ['all', ['==', 'meta', 'midpoint']],
        paint: {
            'circle-radius': 4,
            'circle-color': '#f59e0b',
        },
    },
];

export const Draw = new MapboxDraw({
    displayControlsDefault: false,
    controls: {
        line_string: true,
        trash: true
    },
    styles: ANNEXE_DRAW_STYLES,
});

const DRAW_LIVE_PREVIEW_SOURCE = "draw-live-preview";
const DRAW_LIVE_PREVIEW_LINE = "draw-live-preview-line";
const DRAW_LIVE_PREVIEW_NODES = "draw-live-preview-nodes";
let drawLivePreviewHandlersBound = false;

import {
    utilisateurSiren,
    isLastTokenService,
    authorisedLocation
} from '@/services/auth.services';
import { nbAnnotations, presentToast, showLoading } from './user.services';
// import { NearestPoint } from '@turf/nearest-point';
import Mousetrap from 'mousetrap';


const accessToken = 'pk.eyJ1IjoiZHJld2RldiIsImEiOiJjbGZneWlvMGczZHlqM3JwY2g1Z2E3MTkzIn0.nphlzvagAppkKXjVMxfBZg';
export let map: mapboxgl.Map;
export let geocoder: MapboxGeocoder;

const MARQUEUR_SOURCE_IDS = ['marqueurs', 'marqueurs_fleches', 'marqueurs_croix'] as const;
type MarqueurSourceId = (typeof MARQUEUR_SOURCE_IDS)[number];

const marqueurCollections: Record<MarqueurSourceId, GeoJSON.Feature[]> = {
    marqueurs: [],
    marqueurs_fleches: [],
    marqueurs_croix: [],
};

let marqueurContextMenuBound = false;
/** Sprites du style Mapbox (comme avant le bug) ou pictos canvas de secours. */
let marqueurImageMode: 'pending' | 'style' | 'canvas' = 'pending';

function drawMarqueurOnCanvas(
    ctx: CanvasRenderingContext2D,
    size: number,
    kind: 'rose' | 'fleche' | 'croix'
) {
    ctx.clearRect(0, 0, size, size);
    const cx = size / 2;
    const cy = size / 2;
    if (kind === 'rose') {
        ctx.fillStyle = '#ec4899';
        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 3;
        ctx.beginPath();
        ctx.arc(cx, cy, size * 0.28, 0, Math.PI * 2);
        ctx.fill();
        ctx.stroke();
        ctx.fillStyle = '#ffffff';
        ctx.font = `bold ${Math.round(size * 0.22)}px sans-serif`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('R', cx, cy + 1);
        return;
    }
    if (kind === 'fleche') {
        ctx.fillStyle = '#2563eb';
        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(cx, size * 0.72);
        ctx.lineTo(cx - size * 0.22, size * 0.38);
        ctx.lineTo(cx - size * 0.1, size * 0.38);
        ctx.lineTo(cx - size * 0.1, size * 0.18);
        ctx.lineTo(cx + size * 0.1, size * 0.18);
        ctx.lineTo(cx + size * 0.1, size * 0.38);
        ctx.lineTo(cx + size * 0.22, size * 0.38);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        return;
    }
    ctx.strokeStyle = '#dc2626';
    ctx.lineWidth = 5;
    ctx.lineCap = 'round';
    const pad = size * 0.22;
    ctx.beginPath();
    ctx.moveTo(pad, pad);
    ctx.lineTo(size - pad, size - pad);
    ctx.moveTo(size - pad, pad);
    ctx.lineTo(pad, size - pad);
    ctx.stroke();
}

/** Valeurs historiques (commit 53c8837) — sprites style `drewdev/...`. */
const MARQUEUR_LAYOUT_STYLE = {
    marqueurs: { 'icon-size': 0.2 },
    marqueurs_fleches: { 'icon-size': 0.4, 'icon-offset': [0, -150] as [number, number] },
    marqueurs_croix: { 'icon-size': 0.2 },
} as const;

/** Même icon-size que le style ; image canvas plus grande pour compenser l’absence de sprite HD. */
const MARQUEUR_CANVAS_PX = 96;

function styleMarqueurSpritesReady(): boolean {
    if (!map) return false;
    return (
        map.hasImage('rosalyna-logo-n') &&
        map.hasImage('fleche_marqueur') &&
        map.hasImage('croix_margueur')
    );
}

function ensureMarqueurImagesLoaded() {
    if (!map) return;

    if (styleMarqueurSpritesReady()) {
        marqueurImageMode = 'style';
        return;
    }

    if (marqueurImageMode === 'canvas') return;

    const specs: { id: string; kind: 'rose' | 'fleche' | 'croix' }[] = [
        { id: 'rosalyna-logo-n', kind: 'rose' },
        { id: 'fleche_marqueur', kind: 'fleche' },
        { id: 'croix_margueur', kind: 'croix' },
    ];
    for (const { id, kind } of specs) {
        if (map.hasImage(id)) continue;
        const canvas = document.createElement('canvas');
        canvas.width = MARQUEUR_CANVAS_PX;
        canvas.height = MARQUEUR_CANVAS_PX;
        const ctx = canvas.getContext('2d');
        if (!ctx) continue;
        drawMarqueurOnCanvas(ctx, MARQUEUR_CANVAS_PX, kind);
        const imageData = ctx.getImageData(0, 0, MARQUEUR_CANVAS_PX, MARQUEUR_CANVAS_PX);
        try {
            map.addImage(id, imageData, { pixelRatio: 1 });
        } catch (err) {
            console.warn('[ensureMarqueurImagesLoaded]', id, err);
        }
    }
    marqueurImageMode = 'canvas';
}

function applyMarqueurLayerLayout() {
    if (!map) return;
    const useStyle = styleMarqueurSpritesReady() || marqueurImageMode === 'style';

    if (map.getLayer('marqueurs')) {
        map.setLayoutProperty(
            'marqueurs',
            'icon-size',
            MARQUEUR_LAYOUT_STYLE.marqueurs['icon-size']
        );
    }
    if (map.getLayer('marqueurs_croix')) {
        map.setLayoutProperty(
            'marqueurs_croix',
            'icon-size',
            MARQUEUR_LAYOUT_STYLE.marqueurs_croix['icon-size']
        );
    }
    if (map.getLayer('marqueurs_fleches')) {
        map.setLayoutProperty(
            'marqueurs_fleches',
            'icon-size',
            MARQUEUR_LAYOUT_STYLE.marqueurs_fleches['icon-size']
        );
        if (useStyle) {
            map.setLayoutProperty(
                'marqueurs_fleches',
                'icon-offset',
                MARQUEUR_LAYOUT_STYLE.marqueurs_fleches['icon-offset']
            );
            map.setLayoutProperty('marqueurs_fleches', 'icon-anchor', 'center');
        } else {
            map.setLayoutProperty('marqueurs_fleches', 'icon-offset', [0, 0]);
            map.setLayoutProperty('marqueurs_fleches', 'icon-anchor', 'bottom');
        }
    }
}

function syncMarqueurSource(sourceId: MarqueurSourceId) {
    if (!map?.getSource(sourceId)) return;
    const fc: GeoJSON.FeatureCollection = {
        type: 'FeatureCollection',
        features: marqueurCollections[sourceId],
    };
    (map.getSource(sourceId) as mapboxgl.GeoJSONSource).setData(fc);
}

function clearMarqueurSource(sourceId: MarqueurSourceId) {
    marqueurCollections[sourceId] = [];
    syncMarqueurSource(sourceId);
}

/** Remonte les couches marqueurs au-dessus du PIT / NRO / relevé. */
export function raiseMarqueurLayersOnTop() {
    if (!map) return;
    for (const id of MARQUEUR_SOURCE_IDS) {
        if (map.getLayer(id)) {
            try {
                map.moveLayer(id);
            } catch {
                /* ignore */
            }
        }
    }
}

/** Remonte les couches Mapbox Draw au-dessus du PIT / relevé pendant un tracé. */
export function raiseDrawLayersOnTop() {
    if (!map) return;
    const layers = map.getStyle()?.layers;
    if (!layers) return;
    for (const layer of layers) {
        if (!layer.id.startsWith("gl-draw")) continue;
        try {
            map.moveLayer(layer.id);
        } catch {
            /* ignore */
        }
    }
    raiseDrawLivePreviewLayersOnTop();
}

function raiseDrawLivePreviewLayersOnTop() {
    if (!map) return;
    for (const id of [DRAW_LIVE_PREVIEW_LINE, DRAW_LIVE_PREVIEW_NODES]) {
        if (!map.getLayer(id)) continue;
        try {
            map.moveLayer(id);
        } catch {
            /* ignore */
        }
    }
}

function removeDrawLivePreviewLayers() {
    if (!map) return;
    for (const id of [DRAW_LIVE_PREVIEW_LINE, DRAW_LIVE_PREVIEW_NODES]) {
        if (map.getLayer(id)) {
            try {
                map.removeLayer(id);
            } catch {
                /* ignore */
            }
        }
    }
    if (map.getSource(DRAW_LIVE_PREVIEW_SOURCE)) {
        try {
            map.removeSource(DRAW_LIVE_PREVIEW_SOURCE);
        } catch {
            /* ignore */
        }
    }
}

function updateDrawLivePreviewLayer() {
    if (!map || Draw.getMode() !== "draw_line_string") return;

    const previewFeatures: GeoJSON.Feature[] = [];
    const all = Draw.getAll();
    for (const feature of all.features) {
        if (feature.geometry?.type !== "LineString") continue;
        const coords = feature.geometry.coordinates;
        if (!Array.isArray(coords) || coords.length < 2) continue;
        previewFeatures.push({
            type: "Feature",
            properties: { _kind: "draw-line" },
            geometry: { type: "LineString", coordinates: coords },
        });
        coords.forEach((coord, index) => {
            if (!Array.isArray(coord) || coord.length < 2) return;
            previewFeatures.push({
                type: "Feature",
                properties: { _kind: "draw-node", index },
                geometry: { type: "Point", coordinates: coord },
            });
        });
    }

    const fc: GeoJSON.FeatureCollection = {
        type: "FeatureCollection",
        features: previewFeatures,
    };

    if (!map.getSource(DRAW_LIVE_PREVIEW_SOURCE)) {
        map.addSource(DRAW_LIVE_PREVIEW_SOURCE, { type: "geojson", data: fc });
        map.addLayer({
            id: DRAW_LIVE_PREVIEW_LINE,
            type: "line",
            source: DRAW_LIVE_PREVIEW_SOURCE,
            filter: ["==", ["get", "_kind"], "draw-line"],
            layout: { "line-cap": "round", "line-join": "round" },
            paint: {
                "line-color": "#f59e0b",
                "line-width": 5,
                "line-opacity": 0.98,
                "line-dasharray": [2, 1.5],
            },
        });
        map.addLayer({
            id: DRAW_LIVE_PREVIEW_NODES,
            type: "circle",
            source: DRAW_LIVE_PREVIEW_SOURCE,
            filter: ["==", ["get", "_kind"], "draw-node"],
            paint: {
                "circle-radius": 7,
                "circle-color": "#f59e0b",
                "circle-stroke-width": 2,
                "circle-stroke-color": "#ffffff",
            },
        });
    } else {
        const src = map.getSource(DRAW_LIVE_PREVIEW_SOURCE) as mapboxgl.GeoJSONSource;
        src.setData(fc);
    }
    raiseDrawLayersOnTop();
}

function ensureDrawLivePreviewHandlers() {
    if (!map || drawLivePreviewHandlersBound) return;
    drawLivePreviewHandlersBound = true;

    map.on("draw.render", () => {
        if (Draw.getMode() === "draw_line_string") {
            updateDrawLivePreviewLayer();
        }
    });

    map.on("mousemove", (e) => {
        if (Draw.getMode() !== "draw_line_string") return;
        updateDrawLivePreviewLayer();
    });
}

export function ensureMarqueurLayers() {
    if (!map) return;
    ensureMarqueurImagesLoaded();

    for (const sourceId of MARQUEUR_SOURCE_IDS) {
        if (!map.getSource(sourceId)) {
            map.addSource(sourceId, {
                type: 'geojson',
                data: { type: 'FeatureCollection', features: [] },
            } as mapboxgl.GeoJSONSourceRaw);
        }
        syncMarqueurSource(sourceId);
    }

    if (!map.getLayer('marqueurs_croix')) {
        map.addLayer({
            id: 'marqueurs_croix',
            type: 'symbol',
            source: 'marqueurs_croix',
            layout: {
                'icon-image': 'croix_margueur',
                'icon-allow-overlap': true,
                'icon-size': MARQUEUR_LAYOUT_STYLE.marqueurs_croix['icon-size'],
            },
        });
    }
    if (!map.getLayer('marqueurs_fleches')) {
        map.addLayer({
            id: 'marqueurs_fleches',
            type: 'symbol',
            source: 'marqueurs_fleches',
            layout: {
                'icon-image': 'fleche_marqueur',
                'icon-allow-overlap': true,
                'icon-size': MARQUEUR_LAYOUT_STYLE.marqueurs_fleches['icon-size'],
                'icon-offset': MARQUEUR_LAYOUT_STYLE.marqueurs_fleches['icon-offset'],
            },
        });
    }
    if (!map.getLayer('marqueurs')) {
        map.addLayer({
            id: 'marqueurs',
            type: 'symbol',
            source: 'marqueurs',
            layout: {
                'icon-image': 'rosalyna-logo-n',
                'icon-allow-overlap': true,
                'icon-size': MARQUEUR_LAYOUT_STYLE.marqueurs['icon-size'],
            },
        });
    }

    applyMarqueurLayerLayout();

    if (!marqueurContextMenuBound) {
        map.on('contextmenu', 'marqueurs', (e) => {
            e.preventDefault();
            clearMarqueurSource('marqueurs');
        });
        map.on('contextmenu', 'marqueurs_fleches', (e) => {
            e.preventDefault();
            clearMarqueurSource('marqueurs_fleches');
        });
        map.on('contextmenu', 'marqueurs_croix', (e) => {
            e.preventDefault();
            clearMarqueurSource('marqueurs_croix');
        });
        marqueurContextMenuBound = true;
    }

    raiseMarqueurLayersOnTop();
}

let projetActif = '0';
export const inseeAffiche = ref('');
export let inseeActif = '';
/** Nom du dossier d'etude NRO selectionne (reactif pour le modal de telechargement). */
export const nroActif = ref("");
/** INSEE optionnel pour enrichissement ARCEP mediapost (deduit cote serveur si vide). */
export const nroInseeForEtude = ref("");

/** Bloque les popups appui/chambre pendant la saisie départ/arrivée NRO. */
export const nroAnchorPickBlocksPitPopups = ref(false);

export type NroLoadSummary = {
    etude: string;
    mediapost: number;
    cables: number;
    noeuds: number;
    zoom: number | null;
    /** Repartition des valeurs ca_layer (Distribution, Feeder, Drop, …). */
    caLayerCounts: Record<string, number>;
    /** true si au moins un cable porte ca_layer (ou variante de nom). */
    hasCaLayer: boolean;
    /** Cles des proprietes du 1er cable (debug schema GeoJSON). */
    cablePropertyKeys: string[];
    /** Câbles drop masqués (heuristique extrémité + 2 points). */
    dropsHidden: number;
    /** Câbles masqués par filtre PM actif. */
    pmHidden: number;
    cablesTotal: number;
    /** PM affiché (null = tous). */
    activePmPkUid: number | null;
};

/** Compteurs affiches en footer apres chargement NRO. */
export const nroLoadSummary = ref<NroLoadSummary | null>(null);

/** Filtre drops NRO (extrémité + 2 sommets), mis à jour au chargement cable. */
export const nroCableFilterStats = ref({
  total: 0,
  dropsHidden: 0,
  pmHidden: 0,
  displayed: 0,
  activePmPkUid: null as number | null,
});

/** Mode préparation de commande (relevé terrain + liste câbles). */
export const releve_appuis = ref<unknown>(null);
export const releve_liens = ref<unknown>(null);
export const releveMeta = ref<{
  uploadedAt?: string;
  insee?: string;
  hasAppuis?: boolean;
  hasLiens?: boolean;
} | null>(null);
export const showReleveAppuis = ref(true);
export const showReleveLiens = ref(true);

export const customFci = ref("F00000jjmmaa");

const hasLayer = (id: string) => {
    try {
        return !!map.getLayer(id);
    } catch {
        return false;
    }
};

const hasSource = (id: string) => {
    try {
        return !!map.getSource(id);
    } catch {
        return false;
    }
};

// Attend que la carte soit chargée avant manipulation (sources/couches)
export const waitForMapReady = async (m?: mapboxgl.Map) => {
    const target = m || map;
    if (!target) return;
    if (typeof target.isStyleLoaded === "function" && target.isStyleLoaded()) return;
    await new Promise<void>((resolve) => {
        const handler = () => {
            target.off("load", handler);
            target.off("styledata", handler);
            resolve();
        };
        target.once("load", handler);
        target.once("styledata", handler);
        // Fallback de sécurité
        setTimeout(() => {
            target.off("load", handler);
            target.off("styledata", handler);
            resolve();
        }, 1500);
    });
};


async function getUserSiren() {
    const { value } = await Preferences.get({ key: 'mesinformations' });
    if (value) {
        const parsed = JSON.parse(value)
        return parsed.siren
    }
    return "default"

}

const mapLeft = ref(false)
const mapInit = ref(false)
const ticketmodal = ref('');
export const isOpen = ref(false);
export const isOpenImmeuble = ref(false);
export const isOpenChambre = ref(false);
export const isOpenAppui = ref(false);
export const isOpenConduite = ref(false);
export const isOpenConduiteSupplementaire = ref(false);
export const isOpenDownloadPit = ref(false);
export const downloadPitReason = ref('');
export const isOpenDownloadNro = ref(false);
export const isOpenShortcutModal = ref(false);
export const isOpenPhotosApresTravaux = ref(false);
export const isOpenAnalysePhotosC6 = ref(false);
export const continuerDFT = ref(false);

//const typesFiles = ['appui', 'chambre', 'arcep', 'conduite', 'pbo', 'cable', 'mediapost', 'cadastre_batiments', 'cadastre_parcelles'];

export const boitierTitre = ref("Attente");
export const cablesTitre = ref("Attente");
export const mediapostTitre = ref("Attente");
export const boitierAT = ref(true);
export const cablesAT = ref(true);
export const mediapostAT = ref(true);
export const boitierEC = ref(false);
export const cablesEC = ref(false);
export const mediapostEC = ref(false);
export const boitierTM = ref(false);
export const cablesTM = ref(false);
export const mediapostTM = ref(false);
export const cablesByDiameter = ref(false);
export const boitierINDISP = ref(false);
export const cablesINDISP = ref(false);
export const mediapostINDISP = ref(false);

export const conduitesTitre = ref("Attente");
export const chambreTitre = ref("Attente");
export const arcepTitre = ref("Attente");
export const appuiTitre = ref("Attente");
export const cadastre_batimentsTitre = ref("Attente");
export const cadastre_parcellesTitre = ref("Attente");
export const communeTamponTitre = ref("Attente");

export const conduiteAT = ref(true);
export const chambreAT = ref(true);
export const arcepAT = ref(true);
export const appuiAT = ref(true);
export const cadastre_batimentsAT = ref(true);
export const cadastre_parcellesAT = ref(true);
export const communeTamponAT = ref(true);

export const conduitesEC = ref(false);
export const chambreEC = ref(false);
export const arcepEC = ref(false);
export const appuiEC = ref(false);
export const cadastre_batimentsEC = ref(false);
export const cadastre_parcellesEC = ref(false);
export const communeTamponEC = ref(false);


export const conduitesTM = ref(false);
export const chambreTM = ref(false);
export const arcepTM = ref(false);
export const appuiTM = ref(false);
export const cadastre_batimentsTM = ref(false);
export const cadastre_parcellesTM = ref(false);
export const communeTamponTM = ref(false);

export const conduitesINDISP = ref(false);
export const chambreINDISP = ref(false);
export const arcepINDISP = ref(false);
export const appuiINDISP = ref(false);
export const cadastre_batimentsINDISP = ref(false);
export const cadastre_parcellesINDISP = ref(false);
export const communeTamponINDISP = ref(false);


export const immeubleCible = ref({ immeuble: '', siren: '', adresse: '', codePostal: '', ville: '', insee: '', coord: '', type_imb: '', verif: '' })
export const chambreCible = ref({ chambre: '', siren: '', adresse: '', codePostal: '', ville: '', insee: '', coord: '', type: '', verif: '' })
export const appuiCible = ref({ appui: '', siren: '', adresse: '', codePostal: '', ville: '', insee: '', coord: '', type: '', verif: '' })
export const conduiteCible = ref({ precision: '', fci: '', distance: '', composition: '', siren: '', modepose: '', verif: '', geometry: { coordinates: [] } })
export const selectionPhotosCible = ref({ propositions: [] })
export const selectionC6 = ref({ propositions: [] })
//export const toutesLesPhotos = ref({ propositions: [] as any[] });
export const toutesLesPhotos = ref<any[]>([]);
export const conserverRemplacements = ref(false);
export let gcbloFeatures: GeoJSON.Feature[] = [];
export const resetGcbloFeatures = () => {
    gcbloFeatures = [];
};
export const setGcbloFeatures = (features: GeoJSON.Feature[]) => {
    gcbloFeatures = Array.isArray(features) ? features : [];
};
// Marque les chambres ayant un boîtier selon les câbles chargés
export const markChambresBoitiers = async (cables: GeoJSON.Feature[]) => {
    // Étape 1 : réinitialiser les indicateurs de boîtier sur les chambres actives
    const totalChambres = chambresActif?.features?.length || 0;
    if (!Array.isArray(chambresActif?.features) || !totalChambres) return;
    chambresActif.features.forEach((ch: any) => {
        if (!ch?.properties) return;
        ch.properties.has_boitier = false;
    });

    // Étape 2 : pour chaque câble, marquer la chambre de départ/arrivée si un boîtier est présent
    const normCode = (v: any) => (v === null || v === undefined ? "" : String(v).trim());
    (cables || []).forEach((commande: any) => {
        commande.type = 'Feature';
        const apbo = commande?.apbo ?? commande?.properties?.apbo;
        const bpbo = commande?.bpbo ?? commande?.properties?.bpbo;
        const dep = normCode(commande?.depart ?? commande?.properties?.depart);
        const arr = normCode(commande?.arrivee ?? commande?.properties?.arrivee);
        const depIdx = chambresActif.features.findIndex((ch: any) => normCode(ch?.properties?.CODE_CH1) === dep);
        if (depIdx !== -1 && apbo) {
            chambresActif.features[depIdx].properties.has_boitier = true;
        }
        const arrIdx = chambresActif.features.findIndex((ch: any) => normCode(ch?.properties?.CODE_CH1) === arr);
        if (arrIdx !== -1 && bpbo) {
            chambresActif.features[arrIdx].properties.has_boitier = true;
        }
    });

    // Étape 3 : pousser l’état à la source Mapbox des chambres pour déclencher le restylage
    await updateOrAddSource('chambres', chambresActif);
};
//export const imagesBuffers = ref<any[]>([]);
export let conduiteActif: any;
export let appuisActif: any;
export let chambresActif: any;
export let immeubleActif: any;
export let parcelleActif: any;
export let batimentActif: any;
export let bloquantActif: any;
// commande courante (nom, fci, id mongo le cas échéant)
export const currentCommand = ref<{ precision?: string; fci?: string; id?: string }>({})


export const etude_noeud = ref();
export const etude_mediapost = ref();
export const etude_cable = ref();
/** Zones PM de l'étude NRO (libellés pour le filtre PM). */
export const etude_za_pm = ref<unknown>(null);

export const chargementAppuisAChaud = async (insee: string, correction: string) => {
    try {
        const contents = await Filesystem.readFile({
            path: `appui_${insee}.geojson`,
            directory: folderCapacitor.value,
            encoding: Encoding.UTF8,
        });
        const data = await toStringData(contents.data);
        const geo = JSON.parse(data);
        appuisActif = geo;
        return true;
    } catch (err) {
        console.warn("[chargementAppuisAChaud] PIT absent ou illisible", { insee, err: (err as any)?.message || err });
        listeRemarques.value.message.unshift(
                    `[WARN] Le PIT ${insee} est indisponible ou non téléchargé.`
                  );
        correction = "Non";
        return false;
    }
};

export const chargerNRO = async (id: string, insee: string) => {
    nroActif.value = (id || "").trim();
    nroInseeForEtude.value = (insee || "").trim();
    void import("@/services/nro-topology.services").then((mod) => mod.clearNroTopology());
    void import("@/services/prep-commande.services").then((mod) => mod.leavePrepCommandeMode());
    etude_za_pm.value = null;
    releve_appuis.value = null;
    releve_liens.value = null;
    releveMeta.value = null;
    isOpenDownloadNro.value = true;
    /*const url = `${prodEnvironment.baseUrl}api/data/monetude`;
    const response = await fetch(url, {
        method: "POST",
        credentials: "include",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ etude: id, type: type, insee: inseeActif })
    }).then(async res => {
        const geojson = JSON.parse(await res.text());
        //console.log(geojson)
        switch (type) {
            case 'mediapost':
                etude_mediapost.value = geojson;
                ajouterSource(geojson, 'arcep');
                ajouterCouche('arcep');
                chargerNRO(id, 'cable');
                break;
            case 'cable':
                ajouterSource(geojson, 'etude_cable');
                ajouterCouche('etude_cable');
                chargerNRO(id, 'noeud');
                break;
            case 'noeud':
                etude_noeud.value = geojson;
                ajouterSource(geojson, 'etude_noeud');
                ajouterCouche('etude_noeud');
                activeBpe.value = true;
                break;
        }
    })*/
}

export async function majPIT(insee: any, reason = '') {
    inseeActif = insee;
    downloadPitReason.value = reason || '';
    isOpenDownloadPit.value = true;
    //showConfirm(insee, "Nous allons mettre à jour votre SIG", true)
}

export const consententActionSheet = async (titre: any, table: any) => { //Merci Elvin pour le nom - Eenie Meenie - ok je valide
    const buttons = [];
    for (const element of table) {
        buttons.push({
            text: element.nom,
            role: element.role,
            data: {
                action: 'delete',
            },
        })
    }
    const actionSheet = await actionSheetController.create({
        header: titre,
        buttons: buttons,
    })
    await actionSheet.present();
    const { role } = await actionSheet.onDidDismiss();
    return role;
}

export const presentActionSheet = async (objet: any) => {
    const actionSheet = await actionSheetController.create({
        header: 'Actions',
        buttons: [
            {
                text: 'Appui',
                role: 'appui',
                data: {
                    action: 'delete',
                },
            }, {
                text: 'Appui EDF',
                role: 'appui_edf',
                data: {
                    action: 'delete',
                },
            },
            {
                text: 'Chambre',
                role: 'chambre',
                data: {
                    action: 'delete',
                },
            },
            {
                text: 'Bloquant',
                role: 'bloquant',
                data: {
                    action: 'delete',
                },
            },
            {
                text: 'Logement',
                role: 'logement',
                data: {
                    action: 'share',
                },
            },
            {
                text: 'Marqueur',
                role: 'marqueur',
                data: {
                    action: 'pin',
                },
            },
            {
                text: 'Annuler',
                role: 'cancel',
                data: {
                    action: 'cancel',
                },
            },
        ],
    });
    getAnnotations(false, inseeActif)
    await actionSheet.present();
    const { role } = await actionSheet.onDidDismiss();

    switch (role) {
        case 'appui_edf':
            nouvelleAnnotation(objet, 'appui_edf');
            break;
        case 'appui':
            nouvelleAnnotation(objet, 'appui');
            break;
        case 'chambre':
            //presentToast("L'ajout des chambres n'est pas encore disponible.", "info")
            nouvelleAnnotation(objet, 'chambre');
            break;
        case 'bloquant':
            //console.log('Vous avez choisi bloquant');
            nouvelleAnnotation(objet, 'bloquant');
            break;
        case 'logement':
            //console.log('Vous avez choisi logement');
            nouvelleAnnotation(objet, 'immeuble');
            break;
        case 'marqueur':
            //console.log('Vous avez choisi marqueur');
            nouveauMarqueur(objet, 'rose', true);
            // nouvelleAnnotation(objet, 'marqueur');
            break;
        case 'cancel':
            break;
        default:
            break;
    }
};

export const deleteCommande = async (identifier: any) => {
    const url = `${prodEnvironment.baseUrl}api/gcblo/delete/commande/${identifier}`;
    const response = await fetch(url, {
        method: "DELETE",
        credentials: "include",
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(async res => {

            if (res.status === 200) {
                presentToast('Commande supprimée', 'trash-bin-outline')
                getAnnotations(true, inseeActif)
            } else {
                presentToast('Erreur lors de la suppression de commande', 'warning-outline')
            }
        })
}


export const deleteAnnotation = async (label: any) => {
    const form = { labelCible: label }
    const url = `${prodEnvironment.baseUrl}api/annotation/${label}`;
    const response = await fetch(url, {
        method: "DELETE",
        credentials: "include",
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(async res => {
            //console.log(await res.text())

            if (res.status === 200) {
                presentToast('Annotation supprimée', 'trash-bin-outline')
                getAnnotations(true, inseeActif)
            } else {
                presentToast('Erreur lors de la suppression de l\'annotation', 'warning-outline')
            }
        })
}


export const deleteAppui = async (label: any) => {
    const form = { labelCible: label }
    const url = `${prodEnvironment.baseUrl}api/annotation/${label}`;
    const response = await fetch(url, {
        method: "DELETE",
        credentials: "include",
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(async res => {
            //console.log(await res.text())

            if (res.status === 200) {
                presentToast('Appui supprimé', 'trash-bin-outline')
                getAnnotations(true, inseeActif)
            } else {
                presentToast('Erreur lors de la suppression de l\'appui', 'warning-outline')
            }
        })
}
// Function to extract the number from entity names like "FTx"
function extractNumber(entityName: any) {
    return parseInt(entityName.substring(2));
}

function generate7DigitNumber(): string {
    return Math.floor(1000000 + Math.random() * 9000000).toString();
}

const isAnnotationDuplicate = (type_annot: string, value: string) => {
    const normalize = (v: any) => (v === null || v === undefined ? "" : String(v).trim().toUpperCase());
    const target = normalize(value);
    if (!target) return false;
    const match = (collection: any, keys: string[]) =>
        Array.isArray(collection)
            ? collection.some((f: any) =>
                keys.some((k) => normalize(f?.properties?.[k]) === target)
            )
            : false;
    const checkChambres = () =>
        match(annotations_chambres?.features, ['CODE_CH1', 'label']) ||
        match(chambresActif?.features, ['CODE_CH1', 'label']);
    const checkAppuis = () =>
        match(annotations_appuis?.features, ['NUM_APPUI', 'label']) ||
        match(appuisActif?.features, ['NUM_APPUI', 'label']);
    switch (type_annot) {
        case 'chambre':
            return checkChambres();
        case 'appui':
            return checkAppuis();
        case 'appui_edf':
            return match(annotations_edf?.features, ['NUMERO', 'label']);
        case 'bloquant':
            return match(annotations_bloquants?.features, ['blq_id', 'label']);
        case 'conduite':
            return match(annotations_conduites?.features, ['label']);
        case 'arcep':
            return match(annotations_arcep?.features, ['label']);
        default:
            return (
                match(annotations_arcep?.features, ['label']) ||
                match(annotations_bloquants?.features, ['label']) ||
                checkChambres() ||
                checkAppuis()
            );
    }
};

const requestAnnotationLabel = async (type_annot: string, suggestedLabel: string) => {
    let resolved: string | null = null;
    const alert = await alertController.create({
        header: 'Nom de l’annotation',
        inputs: [
            {
                name: 'label',
                type: 'text',
                value: suggestedLabel,
                placeholder: 'Nom',
            },
        ],
        buttons: [
            { text: 'Annuler', role: 'cancel' },
            {
                text: 'Valider',
                role: 'confirm',
                handler: (data) => {
                    const raw = data?.label;
                    const cleaned = String(raw || "").replace(/[^\w\s]/gi, '').trim();
                    const finalLabel = cleaned || suggestedLabel;
                    if (!finalLabel) {
                        presentToast('Nom invalide : trop court', 'warning-outline');
                        return false;
                    }
                    if (isAnnotationDuplicate(type_annot, finalLabel)) {
                        presentToast('Nom déjà utilisé, choisissez-en un autre.', 'warning-outline');
                        return false;
                    }
                    resolved = finalLabel;
                    return true;
                },
            },
        ],
    });
    await alert.present();
    // Validation temps réel pour activer/désactiver le bouton
    try {
        const inputEl: HTMLInputElement | null = alert.querySelector('input[name="label"]');
        const confirmBtn: HTMLButtonElement | null = alert.querySelector('button.alert-button-role-confirm');
        const validate = () => {
            const raw = inputEl?.value;
            const cleaned = String(raw || "").replace(/[^\w\s]/gi, '').trim();
            const finalLabel = cleaned || suggestedLabel;
            const ok = !!finalLabel && !isAnnotationDuplicate(type_annot, finalLabel);
            if (confirmBtn) confirmBtn.disabled = !ok;
        };
        if (inputEl) inputEl.addEventListener('input', validate);
        validate();
    } catch (e) {
        // ignore UI validation errors
    }
    await alert.onDidDismiss();
    return resolved;
};

const nouvelleAnnotation = async (objet: any, type_annot: any) => {

    showAnnotations.value = true;
    let continuer = false;
    let value_annot = 'false';



    let suggestedLabel = '';
    if (type_annot === 'chambre') {
        const features = annotations_chambres?.features || [];
        const highestFT = features.reduce(function (highest: any, feature: any) {
            const currentNumber = extractNumber(feature?.properties?.CODE_CH1 || 'FT0');
            return Math.max(highest, isNaN(currentNumber) ? 0 : currentNumber);
        }, 0);
        suggestedLabel = 'FT' + (highestFT + 1);
    } else if (type_annot === 'appui') {
        suggestedLabel = 'AE' + generate7DigitNumber();
    } else if (type_annot === 'appui_edf') {
        const features = annotations_edf?.features || [];
        const highestFT = features.reduce(function (highest: any, feature: any) {
            const currentNumber = extractNumber(feature?.properties?.NUMERO || 'BT0');
            return Math.max(highest, isNaN(currentNumber) ? 0 : currentNumber);
        }, 0);
        suggestedLabel = 'BT' + (highestFT + 1);
    } else if (type_annot === 'immeuble') {
        // Logement : suggère un identifiant automatique pour activer la validation
        suggestedLabel = 'LG' + generate7DigitNumber();
    }

    const chosen = await requestAnnotationLabel(type_annot, suggestedLabel);
    if (chosen) {
        continuer = true;
        value_annot = chosen;
    }



    //console.log('Name:', value);
    //console.log('coords:', objet);
    //console.log('Cancelled:', cancelled);
    //console.log(objet)
    let geojson_log;
    const x = objet.lng
    const y = objet.lat
    if (continuer) {
        //console.log("valide")
        switch (type_annot) {
            case 'immeuble':
                geojson_log = {
                    "type": "FeatureCollection",
                    "features": [
                        {
                            "type": "Feature",
                            "properties": {
                                imb_id: value_annot,
                                label: value_annot,
                                message: '',
                                y: objet.lat,
                                x: objet.lng,
                                user_creation: '',
                                date_creation: '',
                                type: type_annot,
                                insee: inseeActif,
                                siren: '',
                                verification_terrain: false,
                                commentaire: []
                            },
                            "geometry": {
                                "type": "Point",
                                "coordinatesPoint": [
                                    x,
                                    y
                                ],

                            }
                        }
                    ]
                }
                break;
            case 'chambre':
                geojson_log = {
                    "type": "FeatureCollection",
                    "features": [
                        {
                            "type": "Feature",
                            "properties": {
                                CODE_CH1: value_annot,
                                label: value_annot,
                                message: '',
                                y: objet.lat,
                                x: objet.lng,
                                user_creation: '',
                                date_creation: '',
                                type: type_annot,
                                insee: inseeActif,
                                CODE_CH2: '',
                                REF_NOTE: 'OHN',
                                REF_CHAMBR: 'OHN',
                                siren: '',
                                verification_terrain: false,
                                commentaire: []
                            },
                            "geometry": {
                                "type": "Point",
                                "coordinatesPoint": [
                                    x,
                                    y
                                ],

                            }
                        }
                    ]
                }
                break;
            case 'bloquant':
                geojson_log = {
                    "type": "FeatureCollection",
                    "features": [
                        {
                            "type": "Feature",
                            "properties": {
                                blq_id: value_annot,
                                label: value_annot,
                                message: '',
                                y: objet.lat,
                                x: objet.lng,
                                user_creation: '',
                                date_creation: '',
                                type: type_annot,
                                insee: inseeActif,
                                siren: '',
                                verification_terrain: false,
                                commentaire: []
                            },
                            "geometry": {
                                "type": "Point",
                                "coordinatesPoint": [
                                    x,
                                    y
                                ],

                            }
                        }
                    ]
                }
                break;
            case 'appui_edf':
                geojson_log = {
                    "type": "FeatureCollection",
                    "features": [
                        {
                            "type": "Feature",
                            "properties": {
                                NUM_APPUI: value_annot,
                                NUMERO: value_annot,
                                TYPE_APPUI: 'EDF',
                                label: value_annot,
                                message: '',
                                y: objet.lat,
                                x: objet.lng,
                                user_creation: '',
                                date_creation: '',
                                type: type_annot,
                                insee: inseeActif,
                                siren: '',
                                verification_terrain: false,
                                commentaire: []
                            },
                            "geometry": {
                                "type": "Point",
                                "coordinatesPoint": [
                                    x,
                                    y
                                ],

                            }
                        }
                    ]
                }
                break;
            case 'appui':
                geojson_log = {
                    "type": "FeatureCollection",
                    "features": [
                        {
                            "type": "Feature",
                            "properties": {
                                NUM_APPUI: value_annot,
                                NUMERO: value_annot,
                                TYPE_APPUI: 'ORT',
                                label: value_annot,
                                message: '',
                                y: objet.lat,
                                x: objet.lng,
                                user_creation: '',
                                date_creation: '',
                                type: type_annot,
                                insee: inseeActif,
                                siren: '',
                                verification_terrain: false,
                                commentaire: []
                            },
                            "geometry": {
                                "type": "Point",
                                "coordinatesPoint": [
                                    x,
                                    y
                                ],

                            }
                        }
                    ]
                }
                break;
            case 'conduite':
                geojson_log = objet;
                break;
        }

        const str = JSON.stringify(geojson_log)
        createAnnotation(str);
    }
}

export const getAnnotationsProxy = () => {
    getAnnotations(true, inseeActif)
}
export const getAnnotations = async (reload: boolean, insee: string) => {
    const url = `${prodEnvironment.baseUrl}api/annotation/${insee}`;
    console.log('getAnnotations is trying to fetch', url);

    fetch(url, { method: 'GET', credentials: 'include', headers: { 'Content-Type': 'application/json' } })

        .then(async res => {
            console.log('getAnnotations is fetching', url);
            const da = await res.text();
            const parsed = JSON.parse(da)
            //console.log(parsed)
            const features_arcep: string | any[] = []
            const features_bloquant: string | any[] = []
            const features_chambre: string | any[] = []
            const features_appui: string | any[] = []
            const features_edf: string | any[] = []
            const features_conduite: string | any[] = []
            //console.log(parsed)

            for (const element of parsed) {
                let objet;
                switch (element.type) {
                    case 'immeuble':
                        objet = {
                            type: 'Feature',
                            properties: {
                                id: element.id,
                                imb_id: element.label,
                                label: element.label,
                                date_creation: element.date_creation,
                                insee: element.insee,
                                siren: element.siren,
                                message: element.message,
                                x: element.x,
                                y: element.y,
                                type: element.type,
                                verification_terrain: element.verification_terrain
                            },
                            geometry: {
                                type: 'Point',
                                coordinates: [
                                    parseFloat(element.x), parseFloat(element.y)
                                ]
                            }
                        }
                        features_arcep.push(objet)
                        break;
                    case 'chambre':
                        objet = {
                            type: 'Feature',
                            properties: {
                                id: element.id,
                                CODE_CH1: element.label,
                                CODE_CH2: element.insee,
                                label: element.label,
                                date_creation: element.date_creation,
                                insee: element.insee,
                                siren: element.siren,
                                message: element.message,
                                x: element.x,
                                y: element.y,
                                type: element.type,
                                verification_terrain: element.verification_terrain
                            },
                            geometry: {
                                type: 'Point',
                                coordinates: [
                                    parseFloat(element.x), parseFloat(element.y)
                                ]
                            }
                        }
                        features_chambre.push(objet)
                        break;
                    case 'bloquant':
                        objet = {
                            type: 'Feature',
                            properties: {
                                id: element.id,
                                label: element.label,
                                date_creation: element.date_creation,
                                insee: element.insee,
                                siren: element.siren,
                                message: element.message,
                                x: element.x,
                                y: element.y,
                                type: element.type,
                                verification_terrain: element.verification_terrain
                            },
                            geometry: {
                                type: 'Point',
                                coordinates: [
                                    parseFloat(element.x), parseFloat(element.y)
                                ]
                            }
                        }
                        features_bloquant.push(objet)
                        break;
                    case 'appui_edf':
                        objet = {
                            type: 'Feature',
                            properties: {
                                id: element.id,
                                NUMERO: element.label,
                                NUM_APPUI: element.label,
                                TYPE_APPUI: element.TYPE_APPUI || 'Enedis',
                                INSEE_COMMU: element.insee,
                                label: element.label,
                                date_creation: element.date_creation,
                                insee: element.insee,
                                siren: element.siren,
                                message: element.message,
                                x: element.x,
                                y: element.y,
                                type: element.type,
                                verification_terrain: element.verification_terrain,
                            },
                            geometry: {
                                type: 'Point',
                                coordinates: [
                                    parseFloat(element.x), parseFloat(element.y)
                                ]
                            }
                        }
                        features_edf.push(objet)
                        break;
                    case 'appui':
                        objet = {
                            type: 'Feature',
                            properties: {
                                id: element.id,
                                NUMERO: element.label,
                                NUM_APPUI: element.label,
                                TYPE_APPUI: element.TYPE_APPUI || 'Orange',
                                INSEE_COMMU: element.insee,
                                label: element.label,
                                date_creation: element.date_creation,
                                insee: element.insee,
                                siren: element.siren,
                                message: element.message,
                                x: element.x,
                                y: element.y,
                                type: element.type,
                                verification_terrain: element.verification_terrain,
                                LIBELLE_CO: "",
                                CODE_VOIE: "",
                                LIBELLE_VO: "",
                                CODE_CENTR: "",
                                CODE_ZONE: "",
                                CODE_ENTIT: null,
                                NUM_VOIE: null,
                                CARACT1: "",
                                CARACT2: "",
                                CARACT3: null,
                                CARACT4: null,
                                CARACT5: null,
                                PRES_ELECT: 0,
                                SUPPORT_PC: 0,
                                PRIVE: null,
                                INACC: null,
                                DSP: null,
                                RECALAGE: null,
                                DESARME: null,
                                ENVIRONN: "",
                                TYPE_PT1: "",
                                ETAT_PT1: "",
                                DECLAS_PT1: null,
                                TYPE_PT2: null,
                                ETAT_PT2: null,
                                DECLAS_PT2: null,
                                TYPE_PT3: null,
                                ETAT_PT3: null,
                                DECLAS_PT3: null,
                                DATE_CREA: "",
                                DATE_EXP: ""
                            },
                            geometry: {
                                type: 'Point',
                                coordinates: [
                                    parseFloat(element.x), parseFloat(element.y)
                                ]
                            }
                        }
                        features_appui.push(objet)
                        break;
                    case 'conduite':
                        objet = {
                            type: 'Feature',
                            properties: {
                                id: element.id,
                                MODE_POSE: element.mode_pose,
                                COMPOSITIO: element.compositio,
                                SHAPE_LEN: element.shape_len,
                                LONGUEUR: element.shape_len,
                                label: element.label,
                                date_creation: element.date_creation,
                                insee: element.insee,
                                siren: element.siren,
                                message: element.message,
                                x: element.x,
                                y: element.y,
                                type: element.type,
                                verification_terrain: element.verification_terrain
                            },
                            geometry: {
                                type: 'MultiLineString',
                                coordinates: element.geometry.coordinates
                            }
                        }
                        features_conduite.push(objet)
                        break;
                }

            }

            annotations_arcep = {
                "type": "FeatureCollection",
                "features": features_arcep
            }
            annotations_conduites = {
                "type": "FeatureCollection",
                "features": features_conduite
            }
            annotations_bloquants = {
                "type": "FeatureCollection",
                "features": features_bloquant
            }
            annotations_chambres = {
                "type": "FeatureCollection",
                "features": features_chambre
            }
            annotations_appuis = {
                "type": "FeatureCollection",
                "features": features_appui
            }
            annotations_edf = {
                "type": "FeatureCollection",
                "features": features_edf
            }

            //console.log(annotations_appuis)
            nbAnnotations.value = features_edf.length + features_arcep.length + features_bloquant.length + features_chambre.length + features_appui.length + features_conduite.length
            ajouterSource(annotations_arcep, 'chemin')
            if (inseeActif != '' && reload == true) {

                chargeruneville(inseeActif, 'conduite', false)
            }
        })
        .catch(err => {
            console.error('Error fetching annotations:', err);
            presentToast('Erreur lors de la récupération des annotations.', 'warning-outline');
        });

}

export const createAnnotation = async (geojsonString: any) => {
    const url = `${prodEnvironment.baseUrl}api/annotation/`;
    //console.log(geojsonString)
    const response = await fetch(url, {
        method: "POST",
        credentials: "include",
        headers: {
            'Content-Type': 'application/json'
        },
        body: geojsonString
    })
        .then(async res => {
            //console.log(await res.text())
            getAnnotations(true, inseeActif)
            const jsonres = await res.json();
            if (res.status === 200) {
                presentToast('Annotation ajoutée', 'create-outline')
            } else {
                //console.log(jsonres)
                presentToast(jsonres.message, 'warning-outline')
            }

        })
}

function removeLastPoint() {
    const allFeatures = Draw.getAll();
    let mostRecentLineString = null;

    // Find the most recently drawn LineString
    for (const feature of allFeatures.features) {
        if (feature.geometry.type === 'LineString') {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (!mostRecentLineString || feature.id > mostRecentLineString.id) {
                mostRecentLineString = feature;
            }
        }
    }

    if (mostRecentLineString) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const coordinates = mostRecentLineString.geometry.coordinates;

        if (coordinates.length > 1) {
            // Remove the last coordinate
            coordinates.pop();

            // Update the feature with the modified coordinates
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            Draw.add(mostRecentLineString);
        } else {
            // If there are less than two coordinates, you might want to consider deleting the entire feature
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            Draw.delete(mostRecentLineString.id);
        }
    }
}

export const getMapService = async () => {
    const info = await Device.getInfo();
    if (info.platform === 'web') {
        map = new mapboxgl.Map({
            container: "mapContainer",
            style: 'mapbox://styles/drewdev/clchnzzg400cm14s0fcjpbduh',
            center: [2.730686, 46.343174],
            zoom: 0,
            accessToken,
            preserveDrawingBuffer: true,
        })
        map.doubleClickZoom.disable();

        (window as any).__mapSvc = { map };


    } else {
        map = new mapboxgl.Map({
            container: "mapContainer",
            style: 'mapbox://styles/drewdev/clchnzzg400cm14s0fcjpbduh',
            center: [2.730686, 46.343174],
            zoom: 0,
            doubleClickZoom: false,
            accessToken,
            trackResize: false,
            preserveDrawingBuffer: true,
        })
    }

    const coordinatesGeocoder = function (query: any) {
        // Match anything which looks like
        // decimal degrees coordinate pair.
        const matches = query.match(
            /^[ ]*(?:Lat: )?(-?\d+\.?\d*)[, ]+(?:Lng: )?(-?\d+\.?\d*)[ ]*$/i
        );
        if (!matches) {
            return null;
        }

        function coordinateFeature(lng: any, lat: any) {
            return {
                center: [lng, lat],
                geometry: {
                    type: 'Point',
                    coordinates: [lng, lat]
                },
                place_name: 'Lat: ' + lat + ' Lng: ' + lng,
                place_type: ['coordinate'],
                properties: {},
                type: 'Feature'
            };
        }

        const coord1 = Number(matches[1]);
        const coord2 = Number(matches[2]);
        const geocodes = [];

        if (coord1 < -90 || coord1 > 90) {
            // must be lng, lat
            geocodes.push(coordinateFeature(coord1, coord2));
        }

        if (coord2 < -90 || coord2 > 90) {
            // must be lat, lng
            geocodes.push(coordinateFeature(coord2, coord1));
        }

        if (geocodes.length === 0) {
            // else could be either lng, lat or lat, lng
            geocodes.push(coordinateFeature(coord1, coord2));
            geocodes.push(coordinateFeature(coord2, coord1));
        }

        return geocodes;
    };

    geocoder = new MapboxGeocoder({
        accessToken: accessToken,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        localGeocoder: coordinatesGeocoder,
        // Limit seach results to Australia.
        countries: 'fr',
        placeholder: 'Rechercher une adresse',
        // Apply a client-side filter to further limit results
        // to those strictly within the New South Wales region.
        filter: function (item: any) {
            // returns true if item contains New South Wales region
            return item.context.some((i: any) => {
                return (
                    i.id.split('.').shift() === 'region'
                );
            });
        },
        mapboxgl: mapboxgl
    })


    map.on('load', async function () {


        // map.loadImage('diamond', (error, image) => {
        //     if (error) throw error;
        //     //console.log(image);
        //     map.addImage('marker-15', image as HTMLImageElement);


        getAnnotations(true, inseeActif);
        const myMaybeNullElement = document.getElementById("mapContainer");
        if (myMaybeNullElement) {
            myMaybeNullElement.classList.remove("opacity-0");
            myMaybeNullElement.classList.add("opacity-1");
        }
        if (authorisedLocation.value === true) {
            map.addControl(
                new mapboxgl.GeolocateControl({
                    positionOptions: {
                        enableHighAccuracy: true
                    },
                    // When active the map will receive updates to the device's location as it changes.
                    trackUserLocation: true,
                    // Draw an arrow next to the location dot to indicate which direction the device is heading.
                    showUserHeading: true
                })
            );
        }

        // Attendre le style Mapbox (sprites rosalyna-logo-n, fleche_marqueur, croix_margueur).
        map.once('idle', () => {
            ensureMarqueurLayers();
        });
        map.on('style.load', () => {
            marqueurImageMode = 'pending';
            ensureMarqueurLayers();
        });

        map.on('click', async (e) => {
            // A feature is being modified
            //isDrawing = true;
            const drawMode = Draw.getMode();
            if (drawMode == 'draw_line_string') {
                if (!e.originalEvent.shiftKey) return;
                const x = Draw.getAll()
                if (!x.features.length) return;
                const id_courant = x.features[0].id
                //console.log("dessin en cours", x)
                // if (x.features.length > 0) {
                //     const coord = x.features[0].geometry.coordinates
                //     const coord1 = coord[coord.length - 1]
                //     const coord2 = [e.lngLat.lng, e.lngLat.lat]
                //     const line = turf.lineString([coord1, coord2]);
                //     const length = turf.length(line, { units: 'kilometers' }) * 1000;
                //     if (length > 100) {
                //         presentToast('Votre tracé ne doit pas dépasser 100m', 'warning-outline')
                //         removeLastPoint()
                //     }
                // }
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                const lineStringCoordinates = x.features[0].geometry.coordinates;
                if (e.originalEvent.shiftKey) {
                    // Remove the last point from the LineString
                    lineStringCoordinates.pop(); // Assuming lineStringCoordinates is your LineString array
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    x.features[0].geometry.coordinates = lineStringCoordinates;
                    const feature = {
                        id: generateRandomCode(32),
                        type: 'Feature',
                        properties: {},
                        geometry: { type: 'LineString', coordinates: lineStringCoordinates }
                    };

                    const coll = {
                        type: 'FeatureCollection',
                        features: [feature]
                    }
                    //Draw.update(id_courant);
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    Draw.set(coll);
                }

                // Update the LineString on the map

            } else {
                //console.log("pas en train de dessiner")
            }
        });



        map.on('click', 'mapCenter-rosalyna', async function (e) {
            presentActionSheet(e.lngLat)
        })
        /*function easing(t: number) {
            return t * (2 - t);
        }
    
        map.getCanvas().addEventListener(
            'keydown',
            e => {
                const deltaDistance = 100;
                e.preventDefault();
                //console.log(e.code)
                if (e.code === 'KeyI') {
                    map.panBy([0, -deltaDistance], {
                        easing: easing
                    });                }
                if (e.code === 'KeyJ') {
                    map.panBy([ -deltaDistance,0], {
                        easing: easing
                    });                }
                if (e.code === 'KeyK') {
                        map.panBy([0,deltaDistance], {

                        easing: easing
                    });                }
                if (e.code === 'KeyL') {
                    map.panBy([ deltaDistance,0], {
                        easing: easing
                    });   
                }

            },
            true);*/

    });
    if (info.platform === 'web') {
        map.addControl(Draw, 'bottom-right');
        ensureDrawLivePreviewHandlers();
        map.addControl(new RulerControl(), 'bottom-right');
        map.on('dblclick', function (e) {
            //map.resize();
            const geoj = {
                type: 'FeatureCollection', features: [{
                    "type": "Feature",
                    "properties": {},
                    "geometry": {
                        "coordinates": [
                            e.lngLat.lng,
                            e.lngLat.lat
                        ],
                        "type": "Point"
                    }
                }]
            }
            //console.log('by');
            //console.log(e.lngLat.lng, e.lngLat.lat)

            ajouterSource(geoj, 'mapCenter')
            ajouterCouche('mapCenter')

        });




    } else {
        map.on('click', function (e) {
            map.resize();

            const geoj = {
                type: 'FeatureCollection', features: [{
                    "type": "Feature",
                    "properties": {},
                    "geometry": {
                        "coordinates": [
                            e.lngLat.lng,
                            e.lngLat.lat
                        ],
                        "type": "Point"
                    }
                }]
            }
            ajouterSource(geoj, 'mapCenter')
            ajouterCouche('mapCenter')
        });
    }
    map.on('idle', async function (e) {
        map.resize();
        isMapReady.value = true;
        const { value: quickLocationINSEE } = await Preferences.get({ key: 'quickLocationINSEE' });



        if (quickLocationINSEE) {
            console.log(quickLocationINSEE);
            chargeruneville(quickLocationINSEE, false);
            await Preferences.remove({ key: 'quickLocationINSEE' });
        }

    });

    map.addControl(geocoder, 'top-right');
    /*map.on('zoomend', function (e) {
        //console.log(map.getZoom())
    });*/
    map.on('draw.create', async function (e) {
        removeDrawLivePreviewLayers();
        const actionSheet = await actionSheetController.create({
            header: 'Type de tracé',
            buttons: [
                {
                    text: 'Câble rapide',
                    role: 'cablepoint',
                    data: {
                        action: 'delete',
                    },
                },
                {
                    text: 'Conduite multipoints',
                    role: 'conduiteunique',
                    data: {
                        action: 'delete',
                    },
                },
                {
                    text: 'Conduites simples',
                    role: 'conduitesmultiples',
                    data: {
                        action: 'delete',
                    },
                },
                {
                    text: 'Annexe C6',
                    role: 'annexec6',
                    data: {
                        action: 'delete',
                    },
                }
                ,
                {
                    text: 'Annuler',
                    role: 'annuler',
                    data: {
                        action: 'delete',
                    },
                }
            ],
        });
        await actionSheet.present();
        const { role } = await actionSheet.onDidDismiss();
        const feature = e.features[0];

        const chambres: any[] = [];
        const cheminement: any[] = [];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const geojson = {}
        let maCapa: any;
        const actionSheetCapacites: { text: any; role: any; data: any; }[] = [];
        switch (role) {
            case 'conduiteunique':
                if (feature.geometry.type === 'LineString') {
                    drawnLine = feature;
                    if (drawnLine) {
                        const coord1 = drawnLine.geometry.coordinates[0];
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        const lineLength = turf.length(drawnLine, { units: 'kilometers' }) * 1000;
                        const coordinates1 = drawnLine.geometry?.coordinates[0]
                        const coordinates2 = drawnLine.geometry?.coordinates[drawnLine.geometry?.coordinates.length - 1]

                        const geometry = snapConduite(coordinates1, coordinates2);
                        drawnLine.geometry.coordinates[0] = geometry[0].geometry.coordinates;
                        drawnLine.geometry.coordinates[drawnLine.geometry?.coordinates.length - 1] = geometry[1].geometry.coordinates;
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        drawnLine.properties = {
                            "label": generateRandomString(),
                            "STATUT": "E",
                            "MODE_POSE": "7",
                            "AUT_PASSAG": "null",
                            "AUT_PASS_1": "null",
                            "NATURE_CON": "E",
                            "TYPE_LONGU": "D",
                            "LONGUEUR": lineLength.toString(),
                            "COMPOSITIO": "1Ø45",
                            "ID_PROPRIE": "1",
                            "ORIGINE": "0",
                            "CLASSE": "C",
                            "SHAPE_LEN": lineLength.toString(),
                            "insee": inseeActif,
                            "ANNOTATION": "1",
                            "type": "conduite"
                        }

                        const multiLineString = convertToMultiLineString(drawnLine)
                        const geojson_log = {
                            "type": "FeatureCollection",
                            "features": [
                                multiLineString
                            ]
                        }
                        const finalDrawnLine = JSON.stringify(geojson_log);
                        createAnnotation(finalDrawnLine)
                    }
                }
                break;
            case 'conduitesmultiples':
                presentToast("L'ajout de conduites multiples n'est pas encore disponible.", "info")
                break;
            case 'cablepoint':
                presentToast("Calcul du câble.", "info")

                feature.geometry.coordinates.map((coorSet: any) => {
                    const point1 = point(coorSet);
                    const nearest = nearestPoint(point1, chambresActif);
                    chambres.push(nearest)
                })
                //console.log("liste de chambres", chambres, chambres.length)

                for (let i = 0; i < chambres.length - 1; i++) {
                    const conduites = chambresEnvirons(chambres[i])
                    if (conduites.error) {
                        continue;
                    }
                    let unique = true;
                    conduites.propositions.map((pr: any) => {
                        //console.log(pr)
                        if (pr.properties.CODE_CH1 == chambres[i + 1].properties.CODE_CH1 && unique == true) {
                            cheminement.push(conduites.propositions_conduite[conduites.propositions.indexOf(pr)])
                            unique = false;
                        }
                    })
                }
                //console.log('cheminement', cheminement)
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                geojson.type = "FeatureCollection"
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                geojson.features = cheminement
                ajouterSource(geojson, 'chemin')
                ajouterCouche('chemin')
                console.log('chambre    ', chambres)
                console.log('arrayChambreCoor', chambres.map((ch) => ch.geometry.coordinates))
                console.log('midpoint', getGeographicMidpoint(chambres.map((ch) => ch.geometry.coordinates)))

                midpoint = getGeographicMidpoint(chambres.map((ch) => ch.geometry.coordinates));
                // Flip [lng, lat] -> [lat, lng] explicitly to avoid parsing issues and ensure correct typings
                midpoint = [midpoint[1], midpoint[0]];
                console.log('midpoint', midpoint)



                actionSheetCapacites.push({
                    text: '12fo',
                    role: '12',
                    data: '6', //6
                })
                actionSheetCapacites.push({
                    text: '24fo',
                    role: '24',
                    data: '7', //7
                })
                actionSheetCapacites.push({
                    text: '36fo',
                    role: '36',
                    data: '8.5', //8,5
                })
                actionSheetCapacites.push({
                    text: '48fo',
                    role: '48',
                    data: '9', //9
                })
                actionSheetCapacites.push({
                    text: '72fo',
                    role: '72',
                    data: '10.5', //10,5
                })
                actionSheetCapacites.push({
                    text: '96fo',
                    role: '96',
                    data: '96', //11
                })
                actionSheetCapacites.push({
                    text: '144fo',
                    role: '144',
                    data: '11.5', //11,5
                })
                actionSheetCapacites.push({
                    text: '288fo',
                    role: '288',
                    data: '14', //14
                })
                actionSheetCapacites.push({
                    text: '576fo',
                    role: '576',
                    data: '16.5', //16,5
                })
                actionSheetCapacites.push({
                    text: '720fo',
                    role: '720',
                    data: '17.5', //17,5
                })
                maCapa = await choixDeCapacite(actionSheetCapacites, 'propositions');
                cheminement.map((cdnt) => {
                    cdnt.properties.capacite = maCapa;
                    cdnt.properties.FCI = fciCommande.value;
                    cdnt.properties.COMMANDE = nomCommande.value;
                })
                if (cheminement.length + 1 === chambres.length) {
                    for (let index = 0; index < chambres.length - 1; index++) {
                        const departChambre = chambres[index].properties.CODE_CH1;
                        const arriveeChambre = chambres[index + 1].properties.CODE_CH1;

                        cheminement[index].properties.DEPART = departChambre;
                        cheminement[index].properties.ARRIVEE = arriveeChambre;


                        //console.log(`DEPART: ${departChambre}, ARRIVEE: ${arriveeChambre}`);
                    }
                } else {
                    console.error("Arrays have incompatible lengths");
                }
                tableauCable.value = { chambres: chambres, conduites: cheminement };
                isOpenArrangePath.value = true;
                //volerVers(midpoint.toString(), 17)


                break;
            case 'annexec6':
                {
                    if (!appuisActif) {
                        presentToast("Chargez les appuis PIT pour générer une Annexe C6", "warning-outline");
                        break;
                    }

                    const c6Action = await actionSheetController.create({
                        header: `Annexe C6 · ${annexeC6DraftLines.length} tracé(s) en attente`,
                        buttons: [
                            { text: "Ajouter ce tracé à la file", role: "c6_add" },
                            { text: "Exporter la file + ce tracé", role: "c6_export_with_current" },
                            { text: "Exporter uniquement la file", role: "c6_export_queue" },
                            { text: "Supprimer le dernier tracé en attente", role: "c6_remove_last" },
                            { text: "Vider la file", role: "c6_clear_queue" },
                            { text: "Annuler", role: "cancel" },
                        ],
                    });
                    await c6Action.present();
                    const { role: c6Role } = await c6Action.onDidDismiss();

                    if (c6Role === "c6_add") {
                        const cable = await pickAnnexeC6CableType();
                        if (!cable || cable === "Annuler") break;
                        queueAnnexeC6TraceWithCable(feature, cable);
                        refreshAnnexeC6DraftVisuals();
                        presentToast(`Tracé ajouté (${annexeC6DraftLines.length} en attente)`, "checkmark-outline");
                        break;
                    }
                    if (c6Role === "c6_remove_last") {
                        if (!annexeC6DraftLines.length) {
                            presentToast("Aucun tracé en attente", "warning-outline");
                        } else {
                            annexeC6DraftLines.pop();
                            refreshAnnexeC6DraftVisuals();
                            presentToast(`Tracé retiré (${annexeC6DraftLines.length} restant)`, "checkmark-outline");
                        }
                        break;
                    }
                    if (c6Role === "c6_clear_queue") {
                        annexeC6DraftLines.splice(0, annexeC6DraftLines.length);
                        refreshAnnexeC6DraftVisuals();
                        presentToast("File des tracés vidée", "checkmark-outline");
                        break;
                    }
                    if (c6Role !== "c6_export_with_current" && c6Role !== "c6_export_queue") {
                        break;
                    }

                    let linesToExport: Array<{ feature: any; cable: string }> = [];
                    if (c6Role === "c6_export_with_current") {
                        const currentCable = await pickAnnexeC6CableType();
                        if (!currentCable || currentCable === "Annuler") break;
                        linesToExport = [
                            ...annexeC6DraftLines.map((d) => ({ feature: d.feature, cable: d.cable })),
                            { feature: cloneFeature(feature), cable: currentCable },
                        ];
                    } else {
                        linesToExport = annexeC6DraftLines.map((d) => ({ feature: d.feature, cable: d.cable }));
                    }

                    const exported = await exportAnnexeC6Lines(
                        linesToExport,
                        c6Role === "c6_export_with_current",
                    );
                    if (!exported) break;
                }
                break;


        }

        Draw.delete([feature.id]);
    });

    map.on('draw.delete', function () {
        drawnLine = null;
    });


    map.on('draw.modechange', function (e) {
        if (e.mode === 'draw_line_string') {
            dessinEnCours.value = true;
            updateDrawLivePreviewLayer();
            raiseDrawLayersOnTop();
        } else {
            dessinEnCours.value = false;
            removeDrawLivePreviewLayers();
        }
    });

    //volerVers(midpoint.toString())

    // });

}

function generateRandomString() {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let randomString = '';

    for (let i = 0; i < 10; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        randomString += characters.charAt(randomIndex);
    }

    return randomString;
}

export function convertToMultiLineString(lineString: any) {
    if (lineString.type !== "Feature" || lineString.geometry.type !== "LineString") {
        throw new Error("Input must be a GeoJSON Feature with LineString geometry");
    }

    const multiLineString = {
        type: "Feature",
        geometry: {
            type: "MultiLineString",
            coordinates: [lineString.geometry.coordinates]
        },
        properties: lineString.properties
    };

    return multiLineString;
}

function cloneFeature<T>(input: T): T {
    return JSON.parse(JSON.stringify(input)) as T;
}

function buildLignesC6FromListeAppuis(listeAppuis: any[], cable: string) {
    const lignesC6: { depart: any; arrivee: any; cable: any; longueur: number; angle: number; nappe: string }[] = [];
    const nappe = annexeC6NappeForCable(cable);
    listeAppuis.forEach((appui: any, index: number) => {
        const currPoint = turf.point([appui.geometry.coordinates[0], appui.geometry.coordinates[1]]);
        let nextPoint;
        if (listeAppuis.length <= index + 1) {
            const prevPoint = turf.point([
                listeAppuis[index - 1].geometry.coordinates[0],
                listeAppuis[index - 1].geometry.coordinates[1],
            ]);
            const angleGradeRetour = requete_angle(
                appui.geometry.coordinates[1],
                appui.geometry.coordinates[0],
                listeAppuis[index - 1].geometry.coordinates[1],
                listeAppuis[index - 1].geometry.coordinates[0]
            );
            lignesC6.push({
                depart: appui.properties.NUM_APPUI,
                arrivee: listeAppuis[index - 1].properties.NUM_APPUI,
                cable,
                longueur: Math.ceil(turf.distance(currPoint, prevPoint, { units: 'kilometers' }) * 1000),
                angle: angleGradeRetour,
                nappe,
            });
        } else {
            nextPoint = turf.point([
                listeAppuis[index + 1].geometry.coordinates[0],
                listeAppuis[index + 1].geometry.coordinates[1],
            ]);
            if (index === 0) {
                lignesC6.push({
                    depart: appui.properties.NUM_APPUI,
                    arrivee: listeAppuis[index + 1].properties.NUM_APPUI,
                    cable,
                    longueur: Math.ceil(turf.distance(currPoint, nextPoint, { units: 'kilometers' }) * 1000),
                    angle: requete_angle(
                        appui.geometry.coordinates[1],
                        appui.geometry.coordinates[0],
                        listeAppuis[index + 1].geometry.coordinates[1],
                        listeAppuis[index + 1].geometry.coordinates[0]
                    ),
                    nappe,
                });
            } else {
                const prevPoint = turf.point([
                    listeAppuis[index - 1].geometry.coordinates[0],
                    listeAppuis[index - 1].geometry.coordinates[1],
                ]);
                const angleGrade = requete_angle(
                    appui.geometry.coordinates[1],
                    appui.geometry.coordinates[0],
                    listeAppuis[index + 1].geometry.coordinates[1],
                    listeAppuis[index + 1].geometry.coordinates[0]
                );
                const angleGradeRetour = requete_angle(
                    appui.geometry.coordinates[1],
                    appui.geometry.coordinates[0],
                    listeAppuis[index - 1].geometry.coordinates[1],
                    listeAppuis[index - 1].geometry.coordinates[0]
                );
                lignesC6.push({
                    depart: appui.properties.NUM_APPUI,
                    arrivee: listeAppuis[index - 1].properties.NUM_APPUI,
                    cable,
                    longueur: Math.ceil(turf.distance(currPoint, prevPoint, { units: 'kilometers' }) * 1000),
                    angle: angleGradeRetour,
                    nappe,
                });
                lignesC6.push({
                    depart: appui.properties.NUM_APPUI,
                    arrivee: listeAppuis[index + 1].properties.NUM_APPUI,
                    cable,
                    longueur: Math.ceil(turf.distance(currPoint, nextPoint, { units: 'kilometers' }) * 1000),
                    angle: angleGrade,
                    nappe,
                });
            }
        }
    });
    return lignesC6;
}

async function pickAnnexeC6CableType() {
    return await consententActionSheet("Câble", [
        { nom: 'L1092-12-P', role: 'L1092-12-P', data: { action: 'delete' } },
        { nom: 'L1092-13-P', role: 'L1092-13-P', data: { action: 'delete' } },
        { nom: 'L1092-14-P', role: 'L1092-14-P', data: { action: 'delete' } },
        { nom: 'L1092-15-P', role: 'L1092-15-P', data: { action: 'delete' } },
        { nom: '98-8-4', role: '98-8-4', data: { action: 'delete' } },
        { nom: '98-14-4', role: '98-14-4', data: { action: 'delete' } },
        { nom: '98-28-4', role: '98-28-4', data: { action: 'delete' } },
        { nom: '98-56-4', role: '98-56-4', data: { action: 'delete' } },
        { nom: '98-112-4', role: '98-112-4', data: { action: 'delete' } },
    ]);
}

async function exportAnnexeC6Lines(
    linesToExport: Array<{ feature: any; cable: string }>,
    clearQueueAfter = false,
): Promise<boolean> {
    if (!linesToExport.length) {
        presentToast("Aucun tracé en attente à exporter", "warning-outline");
        return false;
    }
    if (!appuisActif) {
        presentToast("Chargez les appuis PIT pour générer une Annexe C6", "warning-outline");
        return false;
    }

    const operateur = await consententActionSheet("Opérateur", [
        { nom: 'Corsica Fibra', role: 'Corsica Fibra', data: { action: 'delete' } },
        { nom: 'SFR FTTH', role: 'SFR_FTTH', data: { action: 'delete' } },
        { nom: 'SFR', role: 'SFR', data: { action: 'delete' } },
        { nom: 'Numéricable', role: 'NUMERICABLE', data: { action: 'delete' } },
        { nom: 'Complétel', role: 'COMPLETEL', data: { action: 'delete' } },
    ]);
    const workbook = new ExcelJS.Workbook();
    const response = await fetch('xlsx/GC_BLO_V5_Annexe_C6_v20250707.xlsx');
    const data = await response.arrayBuffer();
    await workbook.xlsx.load(data);
    const worksheetC6 = workbook.getWorksheet("Saisies terrain");

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    workbook.getWorksheet("Saisies terrain").orderNo = 0;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    workbook.getWorksheet("Bases").orderNo = 1;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    workbook.getWorksheet("Photos").orderNo = 2;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    workbook.getWorksheet("Page de garde").orderNo = 3;

    const liensParAppui = new Map<string, AnnexeC6Ligne[]>();
    const registeredLienKeys = new Set<string>();
    const pathSequences: string[][] = [];
    const appuiByNum = new Map<string, any>();
    let firstAppui: any = null;

    for (const item of linesToExport) {
        const { appuiNums, listeAppuis } = snapLineFeatureToAppuis(item.feature);
        for (const appui of listeAppuis) {
            const num = String(appui?.properties?.NUM_APPUI || "").trim();
            if (num) appuiByNum.set(num, appui);
        }
        if (!firstAppui && listeAppuis.length) firstAppui = listeAppuis[0];
        if (appuiNums.length < 2) continue;

        pathSequences.push(appuiNums);
        for (const ligne of buildLignesC6FromListeAppuis(listeAppuis, item.cable)) {
            const depart = String(ligne.depart);
            const arrivee = String(ligne.arrivee);
            const departNorm = normalizeAppuiId(depart);
            const arriveeNorm = normalizeAppuiId(arrivee);
            const dedupeKey = `${departNorm}|${arriveeNorm}|${ligne.cable}`;
            if (registeredLienKeys.has(dedupeKey)) continue;
            registeredLienKeys.add(dedupeKey);

            const list = liensParAppui.get(departNorm) || [];
            list.push({
                depart,
                arrivee,
                cable: ligne.cable,
                longueur: ligne.longueur,
                angle: ligne.angle,
                nappe: ligne.nappe,
            });
            liensParAppui.set(departNorm, list);
        }
    }

    const orderedAppuis = orderAnnexeC6AppuisAlongPaths(pathSequences);
    const allLignesC6: AnnexeC6Ligne[] = [];
    for (const appuiNum of orderedAppuis) {
        const departNorm = normalizeAppuiId(appuiNum);
        const cables = [...(liensParAppui.get(departNorm) || [])].sort(sortAnnexeC6LiensPourAppui);
        allLignesC6.push(...cables);
    }

    if (!allLignesC6.length || !firstAppui) {
        presentToast("Impossible de construire une Annexe C6 avec ces tracés", "warning-outline");
        return false;
    }

    let rowNum = 9;
    let currentAppuiNum = "";
    let isFirstAppuiRow = true;
    allLignesC6.forEach((ligne) => {
        const row = worksheetC6.getRow(rowNum);
        row.getCell(25).value = `${ligne.arrivee}`;
        row.getCell(19).value = `${ligne.cable}`;
        row.getCell(20).value = `${ligne.longueur}`;
        row.getCell(21).value = `${ligne.angle}`;
        row.getCell(22).value = `${ligne.nappe}`;
        if (annexeC6CableBold(ligne.cable)) {
            worksheetC6.getCell(rowNum, 19).font = { bold: true };
        }

        const departNorm = normalizeAppuiId(ligne.depart);
        if (departNorm !== currentAppuiNum) {
            currentAppuiNum = departNorm;
            isFirstAppuiRow = true;
        }

        const appui = appuiByNum.get(ligne.depart) || appuiByNum.get(String(ligne.depart));
        if (appui && isFirstAppuiRow) {
            row.getCell(1).value = `${appui.properties.NUM_APPUI}`;
            switch (appui.properties.TYPE_APPUI) {
                case 'BH8':
                case 'BH7':
                case 'BH6':
                case 'FH8':
                case 'FH7':
                case 'FH6':
                case 'MH8':
                case 'MH7':
                case 'MH6':
                    row.getCell(2).value = `${appui.properties.TYPE_APPUI} S30`;
                    break;
                default:
                    row.getCell(2).value = `${appui.properties.TYPE_APPUI}`;
                    break;
            }
            row.getCell(3).value = [appui.properties.NUM_VOIE, appui.properties.LIBELLE_VO].join(' ').trim();
            row.getCell(4).value = `${appui.geometry.coordinates[1]}`;
            row.getCell(5).value = `${appui.geometry.coordinates[0]}`;
            row.getCell(6).value = `Oui`;
            row.getCell(7).value = `Oui`;
            row.getCell(8).value = `Oui`;
            row.getCell(9).value = `Oui`;
            row.getCell(10).value = `Oui`;
            row.getCell(11).value = `Oui`;
            row.getCell(12).value = `Oui`;
            row.getCell(13).value = `Oui`;
            row.getCell(14).value = `Oui`;
            row.getCell(15).value = appui.properties.ENVIRONN;
        }
        isFirstAppuiRow = false;
        rowNum++;
    });

    worksheetC6.getCell('G3').value = firstAppui.properties.INSEE_COMMU;
    worksheetC6.getCell('E3').value = firstAppui.properties.CODE_CENTR;
    worksheetC6.getCell('E1').value = firstAppui.properties.CODE_ZONE;
    worksheetC6.getCell('C3').value = firstAppui.properties.LIBELLE_CO;
    worksheetC6.getCell('C1').value = 'F00000jjmmaa';
    worksheetC6.getCell('C2').value = operateur;
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    worksheetC6.getCell('F1').value = formattedDate;

    await workbook.xlsx.writeBuffer().then(function (buffer: any) {
        const blob = new Blob([buffer]);
        downloadBlob(blob, 'Annexe C6.xlsx');
    }).catch(async function (error: any) {
        console.warn(error);
    });

    if (clearQueueAfter) {
        annexeC6DraftLines.splice(0, annexeC6DraftLines.length);
        refreshAnnexeC6DraftVisuals();
    }
    presentToast(`Annexe C6 exportée (${allLignesC6.length} ligne(s))`, "checkmark-outline");
    return true;
}

async function exportAnnexeC6DraftQueue() {
    const linesToExport = annexeC6DraftLines.map((d) => ({ feature: d.feature, cable: d.cable }));
    await exportAnnexeC6Lines(linesToExport, true);
}

function queueAnnexeC6TraceWithCable(feature: any, cable: string) {
    const id = `c6_${Date.now()}_${Math.random().toString(16).slice(2, 8)}`;
    annexeC6DraftLines.push({
        id,
        createdAt: new Date().toISOString(),
        feature: cloneFeature(feature),
        cable,
        color: ANNEXE_C6_COLORS[annexeC6DraftLines.length % ANNEXE_C6_COLORS.length],
    });
    return id;
}

function summarizeAnnexeC6Draft(feature: any): { depart: string; arrivee: string; lengthM: number } {
    const coords = feature?.geometry?.coordinates || [];
    if (!Array.isArray(coords) || coords.length < 2) {
        return { depart: "?", arrivee: "?", lengthM: 0 };
    }
    const depart = coords[0];
    const arrivee = coords[coords.length - 1];
    const depNear = nearestPoint(point(depart), appuisActif);
    const arrNear = nearestPoint(point(arrivee), appuisActif);
    const departLabel = String(depNear?.properties?.NUM_APPUI || "?");
    const arriveeLabel = String(arrNear?.properties?.NUM_APPUI || "?");
    const lengthM = Math.round((turf.length(feature, { units: "kilometers" }) || 0) * 1000);
    return { depart: departLabel, arrivee: arriveeLabel, lengthM };
}

function ensureAnnexeC6DraftLayers() {
    if (!map) return;
    if (!map.getSource(ANNEXE_C6_DRAFT_SOURCE)) {
        map.addSource(ANNEXE_C6_DRAFT_SOURCE, {
            type: "geojson",
            data: { type: "FeatureCollection", features: [] },
        });
    }
    if (!map.getLayer(ANNEXE_C6_DRAFT_LINE_LAYER)) {
        map.addLayer({
            id: ANNEXE_C6_DRAFT_LINE_LAYER,
            type: "line",
            source: ANNEXE_C6_DRAFT_SOURCE,
            filter: ["==", ["get", "_kind"], "line"],
            layout: { "line-cap": "round", "line-join": "round" },
            paint: {
                "line-color": ["coalesce", ["get", "color"], "#f59e0b"],
                "line-width": 4,
                "line-opacity": 0.95,
                "line-dasharray": [2, 1.5],
            },
        });
    }
    if (!map.getLayer(ANNEXE_C6_DRAFT_NODE_LAYER)) {
        map.addLayer({
            id: ANNEXE_C6_DRAFT_NODE_LAYER,
            type: "circle",
            source: ANNEXE_C6_DRAFT_SOURCE,
            filter: ["==", ["get", "_kind"], "node"],
            paint: {
                "circle-radius": 6,
                "circle-color": "#f59e0b",
                "circle-stroke-width": 2,
                "circle-stroke-color": "#ffffff",
            },
        });
    }
}

function renderAnnexeC6DraftOverlay() {
    if (!map) return;
    const container = map.getContainer();
    let overlay = document.getElementById(ANNEXE_C6_DRAFT_OVERLAY_ID) as HTMLDivElement | null;
    if (!overlay) {
        overlay = document.createElement("div");
        overlay.id = ANNEXE_C6_DRAFT_OVERLAY_ID;
        overlay.style.position = "absolute";
        overlay.style.top = "76px";
        overlay.style.right = "14px";
        overlay.style.width = "min(420px, calc(100vw - 28px))";
        overlay.style.maxHeight = "320px";
        overlay.style.display = "flex";
        overlay.style.flexDirection = "column";
        overlay.style.overflow = "hidden";
        overlay.style.background = "rgba(17, 24, 39, 0.9)";
        overlay.style.border = "1px solid rgba(255,255,255,0.14)";
        overlay.style.borderRadius = "10px";
        overlay.style.padding = "10px";
        overlay.style.color = "#e5e7eb";
        overlay.style.fontSize = "12px";
        overlay.style.zIndex = "20";
        overlay.style.pointerEvents = "auto";
        container.appendChild(overlay);
    }
    if (!annexeC6DraftLines.length) {
        overlay.style.display = "none";
        return;
    }
    overlay.style.display = "flex";
    overlay.innerHTML = "";
    const header = document.createElement("div");
    header.style.fontWeight = "700";
    header.style.color = "#fbbf24";
    header.style.marginBottom = "6px";
    header.style.flexShrink = "0";
    header.textContent = `Annexe C6 · ${annexeC6DraftLines.length} tracé(s)`;
    overlay.appendChild(header);

    const list = document.createElement("div");
    list.style.flex = "1";
    list.style.minHeight = "0";
    list.style.overflowY = "auto";
    list.style.paddingRight = "2px";

    annexeC6DraftLines.forEach((d, idx) => {
        const s = summarizeAnnexeC6Draft(d.feature);
        const row = document.createElement("div");
        row.style.display = "flex";
        row.style.alignItems = "flex-start";
        row.style.justifyContent = "space-between";
        row.style.gap = "8px";
        row.style.marginTop = "6px";
        row.style.border = "1px solid rgba(255,255,255,0.12)";
        row.style.borderLeft = `4px solid ${d.color}`;
        row.style.borderRadius = "6px";
        row.style.padding = "6px";

        const textWrap = document.createElement("div");
        textWrap.style.flex = "1";
        textWrap.style.minWidth = "0";

        const route = document.createElement("div");
        route.style.overflow = "hidden";
        route.style.textOverflow = "ellipsis";
        route.style.whiteSpace = "nowrap";
        route.textContent = `${idx + 1}. ${s.depart} → ${s.arrivee} · ${s.lengthM}m`;

        const cableLine = document.createElement("div");
        cableLine.style.marginTop = "2px";
        cableLine.style.fontWeight = "600";
        cableLine.style.color = d.color;
        cableLine.style.whiteSpace = "normal";
        cableLine.style.wordBreak = "break-word";
        cableLine.style.lineHeight = "1.35";
        cableLine.textContent = d.cable;

        textWrap.appendChild(route);
        textWrap.appendChild(cableLine);

        const del = document.createElement("button");
        del.type = "button";
        del.textContent = "Suppr";
        del.style.flexShrink = "0";
        del.style.background = "transparent";
        del.style.color = "#fca5a5";
        del.style.border = "1px solid rgba(252,165,165,0.5)";
        del.style.borderRadius = "4px";
        del.style.padding = "2px 6px";
        del.style.cursor = "pointer";
        del.onclick = (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            const at = annexeC6DraftLines.findIndex((x) => x.id === d.id);
            if (at >= 0) {
                annexeC6DraftLines.splice(at, 1);
                refreshAnnexeC6DraftVisuals();
                presentToast("Tracé retiré", "checkmark-outline");
            }
        };

        row.appendChild(textWrap);
        row.appendChild(del);
        list.appendChild(row);
    });
    overlay.appendChild(list);

    const exportBtn = document.createElement("button");
    exportBtn.type = "button";
    exportBtn.textContent = "Exporter";
    exportBtn.style.marginTop = "10px";
    exportBtn.style.width = "100%";
    exportBtn.style.padding = "8px 10px";
    exportBtn.style.background = "#f59e0b";
    exportBtn.style.color = "#111827";
    exportBtn.style.border = "none";
    exportBtn.style.borderRadius = "6px";
    exportBtn.style.fontWeight = "700";
    exportBtn.style.fontSize = "12px";
    exportBtn.style.cursor = "pointer";
    exportBtn.style.flexShrink = "0";
    exportBtn.onclick = async (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        await exportAnnexeC6DraftQueue();
    };
    overlay.appendChild(exportBtn);
}

function refreshAnnexeC6DraftVisuals() {
    if (!map) return;
    ensureAnnexeC6DraftLayers();
    const features: any[] = [];
    annexeC6DraftLines.forEach((d) => {
        const coords = d.feature?.geometry?.coordinates;
        if (!Array.isArray(coords) || coords.length < 2) return;
        features.push({
            type: "Feature",
            properties: { _kind: "line", id: d.id, color: d.color },
            geometry: { type: "LineString", coordinates: coords },
        });
        features.push({
            type: "Feature",
            properties: { _kind: "node", id: `${d.id}_start` },
            geometry: { type: "Point", coordinates: coords[0] },
        });
        features.push({
            type: "Feature",
            properties: { _kind: "node", id: `${d.id}_end` },
            geometry: { type: "Point", coordinates: coords[coords.length - 1] },
        });
    });
    const src = map.getSource(ANNEXE_C6_DRAFT_SOURCE) as mapboxgl.GeoJSONSource | undefined;
    src?.setData({ type: "FeatureCollection", features });
    renderAnnexeC6DraftOverlay();
}


export const getGeolocationStatus = async () => {
    const etatPermission = await Geolocation.checkPermissions();
    if (etatPermission.location === 'granted') {
        return true;
    } else {
        return false;
    }
}

// Fonction pour calculer de nouvelles coordonnées en fonction de la distance et de l'angle
export function calculerNouvellesCoordonnees(latitude: any, longitude: any, distanceEnMetres: number, angleEnDegres: number) {
    let nouvelleLatitude = 0;
    let nouvelleLongitude = 0;
    // Convertir l'angle en radians
    const angleEnRadians = ((90 - angleEnDegres + 360) % 360 * Math.PI) / 180;

    //console.log("Je veux calculer les nouvelles coordonnées partant de "+latitude+" "+longitude+" à "+distanceEnMetres+" mètres à "+angleEnDegres+" degrés")
    // Rayon de la Terre en mètres (approximatif)
    const rayonTerre = 6371000; // En mètres

    // Calculer le déplacement en latitude et longitude
    const deplacementLatitude = (distanceEnMetres / rayonTerre) * (180 / Math.PI);
    const deplacementLongitude = (distanceEnMetres / (rayonTerre * Math.cos(latitude * Math.PI / 180))) * (180 / Math.PI);

    //console.log(deplacementLatitude, deplacementLongitude)
    // Calculer les nouvelles coordonnées
    nouvelleLatitude = parseFloat(latitude) + (deplacementLatitude * Math.cos(angleEnRadians));
    nouvelleLongitude = parseFloat(longitude) + (deplacementLongitude * Math.sin(angleEnRadians));

    //console.log(nouvelleLatitude, nouvelleLongitude)
    // Retourner les nouvelles coordonnées
    return { latitude: nouvelleLatitude, longitude: nouvelleLongitude };
}

export const ajouterSource = async (geojson: any, source: any, dezoom = true, landingCoor?: [number, number]) => {
    try {
        const layerName = source + '-rosalyna'
        if (map.getSource(source)) {
            // Sources mises à jour fréquemment : conserver la couche, seulement setData
            if (
                source === 'gcblo' ||
                source === 'etude_cable' ||
                source === 'etude_noeud'
            ) {
                (map.getSource(source) as mapboxgl.GeoJSONSource).setData(geojson);
            } else {
                map.removeLayer(layerName);
                map.removeSource(source);
            }
        }

        if (source == 'arcep') {
            immeubleActif = geojson;
            if (annotations_arcep.features.length > 0) {
                const filteredAnnotations = annotations_arcep.features.filter((annotation: any) => {
                    return annotation.properties.insee == inseeActif;
                });
                if (showAnnotations.value === true) immeubleActif.features = geojson.features.concat(filteredAnnotations);
                geojson = immeubleActif;
            }
            if (annotations_bloquants.features.length > 0) {
                if (map.getSource('bloquants')) {
                    map.removeLayer('bloquants-rosalyna');
                    map.removeSource('bloquants');
                }
                bloquantActif = annotations_bloquants
                const filteredAnnotations = annotations_bloquants.features.filter((annotation: any) => {
                    return annotation.properties.insee == inseeActif;
                });
                bloquantActif.features = filteredAnnotations;
                //console.log(bloquantActif)
                map.addSource('bloquants', {
                    type: 'geojson',
                    data: bloquantActif
                });
            }
        }

        if (source === 'conduites') {
            conduiteActif = geojson;
            if (annotations_conduites.features.length > 0) {
                const filteredAnnotations = annotations_conduites.features.filter((annotation: any) => {
                    return annotation.properties.insee == inseeActif;
                });
                if (showAnnotations.value === true) conduiteActif.features = geojson.features.concat(filteredAnnotations);
                geojson = conduiteActif;

            }
        }


        if (source === 'chambres') {
            chambresActif = geojson;
            if (annotations_chambres.features.length > 0) {
                const filteredAnnotations = annotations_chambres.features.filter((annotation: any) => {
                    return annotation.properties.insee == inseeActif;
                });
                if (showAnnotations.value === true) chambresActif.features = geojson.features.concat(filteredAnnotations);
                geojson = chambresActif;
            }
        }


        if (source === 'appuis') {
            appuisActif = geojson;
            if (annotations_appuis.features.length > 0) {
                const filteredAnnotations = annotations_appuis.features.filter((annotation: any) => {
                    return annotation.properties.insee == inseeActif;
                });
                if (showAnnotations.value === true) appuisActif.features = geojson.features.concat(filteredAnnotations);
                geojson = appuisActif;
                //console.log(geojson)
            }
            if (annotations_edf.features.length > 0) {
                const filteredAnnotations = annotations_edf.features.filter((annotation: any) => {
                    return annotation.properties.insee == inseeActif;
                });
                if (showAnnotations.value === true) appuisActif.features = geojson.features.concat(filteredAnnotations);
                geojson = appuisActif;
                //console.log(geojson)
            }
        }

        if (source === 'c6preview') {
            presentToast('Chargement de la preview C6', 'create-outline')
            //console.log(geojson)
            //volerVers(geojson.features[0].geometry.coordinates)

            map.flyTo({
                center: [geojson.features[0].geometry.coordinates[0], geojson.features[0].geometry.coordinates[1]],
                zoom: 20,
                pitch: 0,
                essential: true
            });

            /*const bbox = turf.bbox({
                type: 'FeatureCollection',
                features: geojson.features
            });
            //map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]]);
            fitBoundsAsync(map, [[bbox[0], bbox[1]], [bbox[2], bbox[3]]]);
            geocoder.setBbox([bbox[0], bbox[1], bbox[2], bbox[3]])*/
        }

        if (source === 'conduites' || source === 'etude_cable') {
            const featuresForBbox =
                source === 'etude_cable'
                    ? geojson?.features || []
                    : conduiteActif?.features || [];
            if (featuresForBbox.length) {
                const bbox = turf.bbox({
                    type: 'FeatureCollection',
                    features: featuresForBbox,
                });

                const { value: quickLocationLatitude } = await Preferences.get({ key: 'quickLocationLatitude' });
                const { value: quickLocationLongitude } = await Preferences.get({ key: 'quickLocationLongitude' });

                if (quickLocationLatitude && quickLocationLongitude) {
                    map.flyTo({
                        center: [parseFloat(quickLocationLongitude), parseFloat(quickLocationLatitude)],
                        zoom: 20,
                        pitch: 0,
                        essential: true,
                    });
                    await Preferences.remove({ key: 'quickLocationLongitude' });
                    await Preferences.remove({ key: 'quickLocationLatitude' });
                } else if (dezoom) {
                    fitBoundsAsync(map, [
                        [bbox[0], bbox[1]],
                        [bbox[2], bbox[3]],
                    ]);
                    geocoder.setBbox([bbox[0], bbox[1], bbox[2], bbox[3]]);
                }
            }
        }

        const existingSource = map.getSource(source) as mapboxgl.GeoJSONSource | undefined;
        if (existingSource) {
            existingSource.setData(geojson);
        } else {
            map.addSource(source, {
                type: 'geojson',
                data: geojson
            });
        }
    } catch (e) {
        //console.log(e)
    }

    // if (landingCoor) {
    //     volerVers(landingCoor);
    // }
}

// Define a function that returns a Promise
function fitBoundsAsync(map: any, bounds: any, options: { padding?: number; maxZoom?: number; duration?: number } = {}) {
    const { padding = 50, maxZoom = 18, duration = 4000 } = options;
    return new Promise<void>((resolve) => {
        const onEnd = () => {
            map.off("moveend", onEnd);
            resolve();
        };
        map.once("moveend", onEnd);
        map.fitBounds(bounds, { padding, maxZoom, duration });
        setTimeout(() => resolve(), duration + 200);
    });
}

function ensureLambertDefsNro() {
    if (!proj4.defs("EPSG:2154")) {
        proj4.defs(
            "EPSG:2154",
            "+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +units=m +no_defs"
        );
    }
}

/** Convertit une paire de coordonnees etude (WGS84 ou Lambert 93) en [lon, lat]. */
function toWgs84LonLat(x: number, y: number): [number, number] | null {
    if (!Number.isFinite(x) || !Number.isFinite(y)) return null;

    const asWgs = (lon: number, lat: number): [number, number] | null => {
        if (lon < -180 || lon > 180 || lat < -90 || lat > 90) return null;
        return [lon, lat];
    };

    let pair = asWgs(x, y);
    if (pair) return pair;
    pair = asWgs(y, x);
    if (pair) return pair;

    if (x > 100000 && y > 6000000) {
        ensureLambertDefsNro();
        try {
            const [lon, lat] = proj4("EPSG:2154", "EPSG:4326", [x, y]);
            return asWgs(lon, lat);
        } catch {
            return null;
        }
    }
    return null;
}

function flattenPositions(geometry: any): number[][] {
    if (!geometry?.coordinates) return [];
    const coords = geometry.coordinates;
    const type = geometry.type;
    if (type === "Point") return [coords];
    if (type === "LineString" || type === "MultiPoint") return coords;
    if (type === "Polygon" || type === "MultiLineString") return coords.flat(1);
    if (type === "MultiPolygon") return coords.flat(2);
    return [];
}

function featureBoundsWgs84(feature: any): [number, number, number, number] | null {
    const positions = flattenPositions(feature?.geometry);
    let minLon = Infinity;
    let minLat = Infinity;
    let maxLon = -Infinity;
    let maxLat = -Infinity;
    let count = 0;

    for (const pos of positions) {
        const pair = toWgs84LonLat(Number(pos[0]), Number(pos[1]));
        if (!pair) continue;
        const [lon, lat] = pair;
        minLon = Math.min(minLon, lon);
        minLat = Math.min(minLat, lat);
        maxLon = Math.max(maxLon, lon);
        maxLat = Math.max(maxLat, lat);
        count += 1;
    }

    if (!count || !Number.isFinite(minLon)) return null;
    return [minLon, minLat, maxLon, maxLat];
}

function mergeBounds(a: [number, number, number, number], b: [number, number, number, number]) {
    return [
        Math.min(a[0], b[0]),
        Math.min(a[1], b[1]),
        Math.max(a[2], b[2]),
        Math.max(a[3], b[3]),
    ] as [number, number, number, number];
}

function boundsFromGeojson(geo: any): [number, number, number, number] | null {
    if (!geo) return null;
    const features: any[] =
        geo.type === "FeatureCollection"
            ? geo.features || []
            : geo.type === "Feature"
              ? [geo]
              : [];
    let merged: [number, number, number, number] | null = null;
    for (const f of features) {
        const b = featureBoundsWgs84(f);
        if (!b) continue;
        merged = merged ? mergeBounds(merged, b) : b;
    }
    return merged;
}

function mapPositionToWgs84(pos: number[]): number[] {
    const pair = toWgs84LonLat(Number(pos[0]), Number(pos[1]));
    if (!pair) return pos;
    const out = pos.slice();
    out[0] = pair[0];
    out[1] = pair[1];
    return out;
}

function transformGeometryToWgs84(geometry: any): any {
    if (!geometry?.coordinates) return geometry;
    const coords = geometry.coordinates;
    switch (geometry.type) {
        case "Point":
            return { ...geometry, coordinates: mapPositionToWgs84(coords) };
        case "LineString":
        case "MultiPoint":
            return { ...geometry, coordinates: coords.map(mapPositionToWgs84) };
        case "Polygon":
        case "MultiLineString":
            return { ...geometry, coordinates: coords.map((ring: number[][]) => ring.map(mapPositionToWgs84)) };
        case "MultiPolygon":
            return {
                ...geometry,
                coordinates: coords.map((poly: number[][][]) =>
                    poly.map((ring: number[][]) => ring.map(mapPositionToWgs84))
                ),
            };
        default:
            return geometry;
    }
}

/** Normalise un GeoJSON etude (Lambert 93 ou WGS84) pour Mapbox. */
export function normalizeEtudeGeojsonToWgs84(geo: any): any {
    if (!geo) return geo;
    const clone = JSON.parse(JSON.stringify(geo));
    const features: any[] =
        clone.type === "FeatureCollection"
            ? clone.features || []
            : clone.type === "Feature"
              ? [clone]
              : [];
    for (const feature of features) {
        if (feature?.geometry) {
            feature.geometry = transformGeometryToWgs84(feature.geometry);
        }
    }
    return clone;
}

export function countGeojsonFeatures(geo: any): number {
    if (!geo) return 0;
    if (geo.type === "FeatureCollection") {
        return (geo.features || []).filter((f: any) => f?.geometry).length;
    }
    if (geo.type === "Feature" && geo.geometry) return 1;
    return 0;
}

const CA_LAYER_PROP_KEYS = ["ca_layer", "CA_LAYER", "Ca_Layer", "ca_Layer"] as const;

/** Lit ca_layer sur une feature cable (noms de champ usuels des exports etude). */
export function getCableCaLayer(properties: Record<string, unknown> | null | undefined): string | null {
    if (!properties) return null;
    for (const key of CA_LAYER_PROP_KEYS) {
        const raw = properties[key];
        if (raw != null && String(raw).trim() !== "") {
            return String(raw).trim();
        }
    }
    return null;
}

const ETUDE_CABLE_LAYER_ID = 'etude_cable-rosalyna';

function etudeCableCaLayerExpression(): mapboxgl.Expression {
    return [
        'downcase',
        [
            'to-string',
            [
                'coalesce',
                ['get', 'ca_layer'],
                ['get', 'CA_LAYER'],
                ['get', 'Ca_Layer'],
                ['get', 'ca_Layer'],
                '',
            ],
        ],
    ];
}

function etudeCableCaPoseExpression(): mapboxgl.Expression {
    return [
        'downcase',
        [
            'to-string',
            ['coalesce', ['get', 'ca_pose'], ['get', 'CA_POSE'], ['get', 'Ca_Pose'], ''],
        ],
    ];
}

/** true si câble exclu du mode préparation (souterrain / _prep_souterrain). */
function etudeCablePrepExcludedExpression(): mapboxgl.Expression {
    return [
        'any',
        ['==', ['get', '_prep_souterrain'], 1],
        ['==', ['get', '_prep_souterrain'], true],
        ['==', etudeCableCaLayerExpression(), 'souterrain'],
        ['==', etudeCableCaPoseExpression(), 'souterrain'],
    ];
}

function etudeCableCapacityColorExpression(): mapboxgl.Expression {
    return [
        'match',
        [
            'to-number',
            [
                'coalesce',
                ['get', 'type_cable_capacite'],
                ['get', 'capacite'],
                ['get', 'ca_capacit'],
                ['get', 'type_cable'],
                ['get', 'CAPACITE'],
                0,
            ],
        ],
        12, '#F00020',
        24, '#0000FF',
        36, '#FF6600',
        48, '#FF6600',
        72, '#7F00FF',
        96, '#00FFFF',
        144, '#FD6C9E',
        288, '#34C924',
        '#ea580c',
    ];
}

function etudeCableLineWidthExpression(): mapboxgl.Expression {
    return [
        'interpolate',
        ['linear'],
        ['zoom'],
        10, 2,
        14, 4,
        18, 7,
    ];
}

/** Style des câbles d'étude : gris / transparent pour Souterrain en mode préparation. */
export function applyEtudeCableLayerStyle(prepMode: boolean): void {
    if (!map || !hasLayer(ETUDE_CABLE_LAYER_ID)) return;

    const capacityColor = etudeCableCapacityColorExpression();
    const excluded = etudeCablePrepExcludedExpression();

    if (prepMode) {
        map.setPaintProperty(ETUDE_CABLE_LAYER_ID, 'line-color', [
            'case',
            excluded,
            '#94a3b8',
            capacityColor,
        ]);
        map.setPaintProperty(ETUDE_CABLE_LAYER_ID, 'line-opacity', [
            'case',
            excluded,
            0.38,
            0.92,
        ]);
    } else {
        map.setPaintProperty(ETUDE_CABLE_LAYER_ID, 'line-color', capacityColor);
        map.setPaintProperty(ETUDE_CABLE_LAYER_ID, 'line-opacity', 0.92);
    }
    map.setPaintProperty(ETUDE_CABLE_LAYER_ID, 'line-width', etudeCableLineWidthExpression());
}

/** Applique le style prep une fois la couche câble prête (évite un no-op si la couche n'existe pas encore). */
export async function applyEtudeCableLayerStyleAsync(prepMode: boolean): Promise<boolean> {
    await waitForMapReady();
    for (let attempt = 0; attempt < 40; attempt += 1) {
        if (map && hasLayer(ETUDE_CABLE_LAYER_ID)) {
            applyEtudeCableLayerStyle(prepMode);
            return true;
        }
        await new Promise((resolve) => setTimeout(resolve, 125));
    }
    console.warn('[applyEtudeCableLayerStyleAsync] couche etude_cable absente');
    return false;
}

function geojsonFeatures(geo: any): any[] {
    if (!geo) return [];
    if (geo.type === "FeatureCollection") return geo.features || [];
    if (geo.type === "Feature") return [geo];
    return [];
}

/** Compte les valeurs ca_layer presentes dans cable.geojson. */
export function summarizeCableCaLayers(geo: any): Record<string, number> {
    const counts: Record<string, number> = {};
    for (const feature of geojsonFeatures(geo)) {
        if (!feature?.geometry) continue;
        const layer = getCableCaLayer(feature.properties) ?? "(sans ca_layer)";
        counts[layer] = (counts[layer] || 0) + 1;
    }
    return counts;
}

export function sampleCablePropertyKeys(geo: any, maxKeys = 14): string[] {
    const features = geojsonFeatures(geo).filter((f) => f?.geometry);
    if (!features.length) return [];
    const keys = new Set<string>();
    for (const feature of features.slice(0, 5)) {
        Object.keys(feature.properties || {}).forEach((k) => keys.add(k));
    }
    return Array.from(keys).sort().slice(0, maxKeys);
}

export function refreshNroLoadSummary(etude?: string) {
    const name = (etude || nroActif.value || "").trim();
    if (!name) {
        nroLoadSummary.value = null;
        return;
    }
    const caLayerCounts = summarizeCableCaLayers(etude_cable.value);
    const hasCaLayer = Object.keys(caLayerCounts).some(
        (k) => k !== "(sans ca_layer)"
    );
    nroLoadSummary.value = {
        etude: name,
        mediapost: countGeojsonFeatures(etude_mediapost.value),
        cables: countGeojsonFeatures(etude_cable.value),
        noeuds: countGeojsonFeatures(etude_noeud.value),
        zoom: map?.getZoom?.() ?? null,
        caLayerCounts,
        hasCaLayer,
        cablePropertyKeys: sampleCablePropertyKeys(etude_cable.value),
        dropsHidden: nroCableFilterStats.value.dropsHidden,
        pmHidden: nroCableFilterStats.value.pmHidden,
        cablesTotal: nroCableFilterStats.value.total,
        activePmPkUid: nroCableFilterStats.value.activePmPkUid,
    };
}

const NRO_MIN_ZOOM = 15.5;

/** Cadre la carte sur une entité GeoJSON (ex. un câble d'étude). */
export async function zoomSurGeojsonFeature(
    feature: GeoJSON.Feature,
    options?: { padding?: number; maxZoom?: number; duration?: number }
): Promise<void> {
    await waitForMapReady();
    if (!map) return;

    const bounds = featureBoundsWgs84(feature);
    if (!bounds) return;

    const { padding = 72, maxZoom = 18, duration = 900 } = options || {};
    const [minLon, minLat, maxLon, maxLat] = bounds;
    const span = Math.max(maxLon - minLon, maxLat - minLat);

    if (span < 1e-6) {
        await volerVers(`${minLat},${minLon}`, Math.min(maxZoom, 18));
        refreshNroLoadSummary();
        return;
    }

    await fitBoundsAsync(
        map,
        [
            [minLon, minLat],
            [maxLon, maxLat],
        ],
        { padding, maxZoom, duration }
    );
    refreshNroLoadSummary();
}

/** Cadre la carte sur une ou plusieurs coordonnées [lon, lat]. */
export async function zoomSurCoordinates(
    coordinates: [number, number][],
    options?: { padding?: number; maxZoom?: number; duration?: number }
): Promise<void> {
    await waitForMapReady();
    if (!map || !coordinates.length) return;

    const { padding = 72, maxZoom = 18, duration = 900 } = options || {};

    if (coordinates.length === 1) {
        const [lon, lat] = coordinates[0];
        await volerVers(`${lat},${lon}`, Math.min(maxZoom, 18));
        refreshNroLoadSummary();
        return;
    }

    let minLon = Infinity;
    let minLat = Infinity;
    let maxLon = -Infinity;
    let maxLat = -Infinity;
    for (const [lon, lat] of coordinates) {
        minLon = Math.min(minLon, lon);
        minLat = Math.min(minLat, lat);
        maxLon = Math.max(maxLon, lon);
        maxLat = Math.max(maxLat, lat);
    }

    const span = Math.max(maxLon - minLon, maxLat - minLat);
    if (span < 1e-6) {
        await volerVers(`${minLat},${minLon}`, Math.min(maxZoom, 18));
        refreshNroLoadSummary();
        return;
    }

    await fitBoundsAsync(
        map,
        [
            [minLon, minLat],
            [maxLon, maxLat],
        ],
        { padding, maxZoom, duration }
    );
    refreshNroLoadSummary();
}

/** Cadre la carte sur les câbles d'étude actuellement affichés (filtre PM / drops appliqué). */
export async function zoomSurEtudeCables(options?: {
    padding?: number;
    maxZoom?: number;
    duration?: number;
}): Promise<void> {
    await waitForMapReady();
    if (!map) return;

    const bounds = boundsFromGeojson(etude_cable.value);
    if (!bounds) return;

    const { padding = 56, maxZoom = 17.5, duration = 1400 } = options || {};
    const [minLon, minLat, maxLon, maxLat] = bounds;
    const span = Math.max(maxLon - minLon, maxLat - minLat);

    if (span < 1e-6) {
        await volerVers(`${minLat},${minLon}`, Math.min(maxZoom, 17));
        refreshNroLoadSummary();
        return;
    }

    await fitBoundsAsync(
        map,
        [
            [minLon, minLat],
            [maxLon, maxLat],
        ],
        { padding, maxZoom, duration }
    );
    refreshNroLoadSummary();
}

/** Cadre la carte sur le NRO charge (cables + boitiers, pas le PIT ARCEP global). */
export const zoomSurEtudeNro = async () => {
    await waitForMapReady();
    if (!map) return;

    let bounds = boundsFromGeojson(etude_cable.value);
    const noeudBounds = boundsFromGeojson(etude_noeud.value);
    if (noeudBounds) {
        bounds = bounds ? mergeBounds(bounds, noeudBounds) : noeudBounds;
    }
    if (!bounds) {
        bounds = boundsFromGeojson(etude_mediapost.value);
    }
    if (!bounds) return;

    const [minLon, minLat, maxLon, maxLat] = bounds;
    const span = Math.max(maxLon - minLon, maxLat - minLat);

    if (span < 1e-6) {
        volerVers(`${minLat},${minLon}`, 17);
        refreshNroLoadSummary();
        return;
    }

    await fitBoundsAsync(
        map,
        [
            [minLon, minLat],
            [maxLon, maxLat],
        ],
        { padding: 48, maxZoom: 17.5, duration: 2200 }
    );

    if (map.getZoom() < NRO_MIN_ZOOM) {
        const center = map.getCenter();
        await new Promise<void>((resolve) => {
            const onEnd = () => {
                map.off("moveend", onEnd);
                resolve();
            };
            map.once("moveend", onEnd);
            map.flyTo({
                center: [center.lng, center.lat],
                zoom: NRO_MIN_ZOOM,
                duration: 1200,
                essential: true,
            });
            setTimeout(() => resolve(), 1400);
        });
    }

    try {
        geocoder?.setBbox([minLon, minLat, maxLon, maxLat]);
    } catch {
        /* geocoder optionnel */
    }
    refreshNroLoadSummary();
};

export const ajouterCouche = (source: any) => {
    try {
        if (!hasSource(source)) {
            return;
        }
        switch (source) {
            case 'c6preview':
                if (hasLayer(source + '-rosalyna')) break;
                map.addLayer({
                    'id': source + '-rosalyna',
                    'type': 'symbol',
                    'minzoom': 13,
                    'source': source,
                    'layout': {
                        'icon-image': [
                            'case',
                            ['==', ['slice', ['get', 'NOM'], 0, 2], 'BT'], 'poteau-electrique',
                            'AP (1)'
                        ],
                        'icon-size': [
                            'case',
                            ['==', ['slice', ['get', 'NOM'], 0, 2], 'BT'], 0.48,
                            0.2
                        ],
                        'text-field': ['get', 'NOM'],
                        'text-font': [
                            'Open Sans Semibold',
                            'Arial Unicode MS Bold'
                        ],
                        'text-offset': [0, 1.25],
                        'text-anchor': 'top'
                    },
                    'paint': {
                        'text-color': '#000',
                        'text-halo-color': [
                            'case',
                            ['==', ['slice', ['get', 'NOM'], 0, 2], 'BT'], '#ebba34',
                            '#ebba34'
                        ],
                        'text-halo-width': 1
                    }
                });
                break;
            case 'c6linepreview':
                if (hasLayer(source + '-rosalyna')) break;
                map.addLayer({
                    'id': source + '-rosalyna',
                    'type': 'line',
                    'source': source,
                    'paint': {
                        'line-width': 4,
                        'line-color': '#ebba34'
                    }
                });
                break;
            case 'gcblo': {
                if (!hasLayer(source + '-rosalyna')) {
                    map.addLayer({
                        'id': source + '-rosalyna',
                        'type': 'line',
                        'source': source,
                        'paint': {
                            'line-width': 4,
                            'line-color': '#00faaf',
                            'line-offset': 0
                        }
                    });
                }
                applyGcbloStyle(cablesByDiameter.value);
                break;
            }
            case 'chemin':
                map.addLayer({
                    'id': source + '-rosalyna',
                    'type': 'line',
                    'source': source,
                    'paint': {
                        'line-width': 4,
                        'line-color': '#0000FF'
                    }
                });
                break;
            case 'chemin2':
                map.addLayer({
                    'id': source + '-rosalyna',
                    'type': 'line',
                    'source': source,
                    'paint': {
                        'line-width': 4,
                        'line-color': '#00f0b0'
                    }
                });
                break;
            case 'etude_cable': {
                const cableLayerId = source + '-rosalyna';
                if (hasLayer(cableLayerId)) {
                    try {
                        map.removeLayer(cableLayerId);
                    } catch {
                        /* ignore */
                    }
                }
                map.addLayer({
                    'id': source + '-rosalyna',
                    'type': 'line',
                    'minzoom': 10,
                    'source': source,
                    'paint': {
                        'line-width': etudeCableLineWidthExpression(),
                        'line-opacity': 0.92,
                        'line-color': etudeCableCapacityColorExpression(),
                    },
                });
                void import("@/services/prep-commande.services").then((mod) => {
                    void applyEtudeCableLayerStyleAsync(mod.prepCommandeActif.value);
                });
                showCD2.value = true;
                cablesAT.value = false;
                cablesEC.value = false;
                cablesTM.value = true;
                cablesINDISP.value = false;
                void import("@/services/nro-topology.services").then((mod) => {
                    mod.ensureNroCableHitLayer();
                    mod.raiseNroLayersOnTop();
                    mod.registerNroTopologyMapHandlers();
                });
                break;
            }
            case 'etude_noeud': {
                const noeudLayerId = source + '-rosalyna';
                if (hasLayer(noeudLayerId)) {
                    try {
                        map.removeLayer(noeudLayerId);
                    } catch {
                        /* ignore */
                    }
                }
                map.addLayer({
                    'id': source + '-rosalyna',
                    'type': 'symbol',
                    'minzoom': 12,
                    'source': source,
                    'layout': {
                        'icon-image': 'chb',
                        'icon-size': [
                            'interpolate',
                            ['linear'],
                            ['zoom'],
                            12, 0.35,
                            16, 0.55,
                            18, 0.75,
                        ],
                        'text-field': ['get', 'no_lib'],
                        'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
                        'text-offset': [0, 0.6],
                        'text-anchor': 'top'
                    },
                    'paint': {
                        'text-color': '#000',
                        'text-halo-color': '#9bff38',
                        'text-halo-width': 1
                        , 'text-opacity': [
                            'match', ['get', 'no_pose'],
                            "CHAMBRE",
                            1,
                            "POTEAU",
                            1,
                            "FACADE",
                            1,
                            "ARMOIRE",
                            1,
                            0
                        ]
                    }
                });
                showBD2.value = true;
                boitierAT.value = false;
                boitierEC.value = false;
                boitierTM.value = true;
                boitierINDISP.value = false;
                break;
            }
            case 'releve_appuis': {
                const layerId = source + '-rosalyna';
                if (hasLayer(layerId)) {
                    try {
                        map.removeLayer(layerId);
                    } catch {
                        /* ignore */
                    }
                }
                map.addLayer({
                    id: layerId,
                    type: 'circle',
                    source,
                    minzoom: 10,
                    paint: {
                        'circle-radius': [
                            'interpolate',
                            ['linear'],
                            ['zoom'],
                            10, 4,
                            16, 7,
                        ],
                        'circle-color': '#0d9488',
                        'circle-stroke-width': 2,
                        'circle-stroke-color': '#ffffff',
                    },
                });
                if (!hasLayer(layerId + '-label')) {
                    map.addLayer({
                        id: layerId + '-label',
                        type: 'symbol',
                        source,
                        minzoom: 14,
                        layout: {
                            'text-field': [
                                'coalesce',
                                ['get', 'NUM_APPUI'],
                                ['get', 'num_appui'],
                                ['get', 'NOM'],
                                '',
                            ],
                            'text-size': 11,
                            'text-offset': [0, 1.2],
                            'text-anchor': 'top',
                        },
                        paint: {
                            'text-color': '#0f766e',
                            'text-halo-color': '#ffffff',
                            'text-halo-width': 1,
                        },
                    });
                }
                showReleveAppuis.value = true;
                break;
            }
            case 'releve_liens': {
                const layerId = source + '-rosalyna';
                if (hasLayer(layerId)) {
                    try {
                        map.removeLayer(layerId);
                    } catch {
                        /* ignore */
                    }
                }
                map.addLayer({
                    id: layerId,
                    type: 'line',
                    source,
                    minzoom: 10,
                    layout: { 'line-cap': 'round', 'line-join': 'round' },
                    paint: {
                        'line-width': [
                            'interpolate',
                            ['linear'],
                            ['zoom'],
                            10, 2,
                            16, 4,
                        ],
                        'line-color': '#db2777',
                        'line-opacity': 0.9,
                    },
                });
                showReleveLiens.value = true;
                void import('@/services/nro-topology.services').then((mod) => {
                    mod.raiseNroLayersOnTop();
                });
                break;
            }
            case 'batiment':
                if (!hasLayer(source + '-rosalyna1')) {
                    map.addLayer({
                        'id': source + '-rosalyna1',
                        'type': 'fill',
                        'source': source, // reference the data source
                        'layout': {},
                        'paint': {
                            'fill-color': '#111827',
                            'fill-opacity': 0.08
                        }
                    });
                }
                if (!hasLayer(source + '-rosalyna2')) {
                    map.addLayer({
                        'id': source + '-rosalyna2',
                        'type': 'line',
                        'source': source,
                        'layout': {},
                        'paint': {
                            'line-color': '#000',
                            'line-width': 0.5,
                            'line-opacity': 0.5
                        }
                    });
                }
                gestionCadastre(source, showCadastre.value);
                break;
            case 'parcelle':
                if (!hasLayer(source + '-rosalyna1')) {
                    map.addLayer({
                        'id': source + '-rosalyna1',
                        'type': 'fill',
                        'source': source, // reference the data source
                        'layout': {},
                        'paint': {
                            'fill-color': '#f59e0b',
                            'fill-opacity': 0.05
                        }
                    });
                }

                if (!hasLayer('titre-parcelle')) {
                    map.addLayer({
                        'id': 'titre-parcelle',
                        'type': 'symbol',
                        'source': source,
                        'layout': {
                            'text-field': ['get', 'id'],
                            'text-font': ['Open Sans Regular'],
                            'text-size': 8
                        },
                        'paint': {
                            'text-color': '#000000'
                        }
                    });
                }

                if (!hasLayer(source + '-rosalyna2')) {
                    map.addLayer({
                        'id': source + '-rosalyna2',
                        'type': 'line',
                        'source': source,
                        'layout': {},
                        'paint': {
                            'line-color': '#000',
                            'line-width': 0.5,
                            'line-opacity': 0.5
                        }
                    });
                }
                gestionCadastre(source, showCadastre.value);
                break;
            case 'commune_tampon':
                map.addLayer({
                    'id': source + '-fill',
                    'type': 'fill',
                    'source': source,
                    'layout': {},
                    'paint': {
                        'fill-color': '#1d4ed8',
                        'fill-opacity': 0.05
                    }
                });
                map.addLayer({
                    'id': source + '-line',
                    'type': 'line',
                    'source': source,
                    'layout': {},
                    'paint': {
                        'line-color': '#1d4ed8',
                        'line-width': 2,
                        'line-opacity': 0.8
                    }
                });
                communeTamponAT.value = false;
                communeTamponTM.value = true;
                communeTamponINDISP.value = false;
                break;
            case 'mapCenter':
                map.addLayer(
                    {
                        'id': source + '-rosalyna',
                        'type': 'symbol',
                        'source': source,
                        'layout': {
                            'icon-image': 'mapcentre',
                            'icon-size': 0.2,
                            'text-font': [
                                'Open Sans Semibold',
                                'Arial Unicode MS Bold'
                            ],
                            'text-offset': [0, 1.25],
                            'text-anchor': 'top'
                        },
                        'paint': {
                            'text-color': '#000',
                            'text-halo-color': '#a69af5',
                            'text-halo-width': 1
                        }
                    },
                )

                break;
            case 'appuis':
                map.addLayer(
                    {
                        'id': source + '-rosalyna',
                        'type': 'symbol',
                        'minzoom': 13,
                        'source': source,
                        'layout': {
                            'icon-image': [
                                'case',
                                ['==', ['slice', ['get', 'NUM_APPUI'], 0, 2], 'BT'], 'poteau-electrique',
                                'AP (1)'
                            ],
                            'icon-size': [
                                'case',
                                ['==', ['slice', ['get', 'NUM_APPUI'], 0, 2], 'BT'], 0.48,
                                0.2
                            ],
                            'text-field': ['get', 'NUM_APPUI'],
                            'text-font': [
                                'Open Sans Semibold',
                                'Arial Unicode MS Bold'
                            ],
                            'text-offset': [0, 1.25],
                            'text-anchor': 'top'
                        },
                        'paint': {
                            'text-color': '#000',
                            'text-halo-color': [
                                'case',
                                ['==', ['slice', ['get', 'NUM_APPUI'], 0, 2], 'BT'], '#75fffd',
                                '#a69af5'
                            ],
                            'text-halo-width': 1
                        }
                    }
                );

                /*map.addLayer(
                    {
                        'id': source + '-rosalyna',
                        'type': 'symbol',
                        'minzoom': 13,
                        'source': source,
                        'layout': {
                            'icon-image': 'AP (1)',
                            'icon-size': 0.2,
                            'text-field': ['get', 'NUM_APPUI'],
                            'text-font': [
                                'Open Sans Semibold',
                                'Arial Unicode MS Bold'
                            ],
                            'text-offset': [0, 1.25],
                            'text-anchor': 'top'
                        },
                        'paint': {
                            'text-color': '#000',
                            'text-halo-color': '#a69af5',
                            'text-halo-width': 1
                        }
                    },
                )*/
                if (eventsMapboxAppui.value === false) {
                    map.on('click', 'appuis-rosalyna', async function (e: any) {

                        if (nroAnchorPickBlocksPitPopups.value) return;
                        if (e.features && dessinEnCours.value === false && selectionCouche.value === 'appuis') {
                            isLastTokenService();
                            let inseeAppui = e.features[0].properties.CODE_COMMU;
                            if (e.features[0].properties.CODE_COMMU == undefined) {
                                inseeAppui = e.features[0].properties.INSEE_COMMU;
                            }
                            appuiCible.value.appui = e.features[0].properties.NUM_APPUI;
                            appuiCible.value.siren = utilisateurSiren.value;
                            appuiCible.value.adresse = e.features[0].properties.LIBELLE_VO;
                            appuiCible.value.codePostal = '';
                            appuiCible.value.ville = e.features[0].properties.LIBELLE_CO;
                            appuiCible.value.insee = inseeAppui;
                            appuiCible.value.coord = e.features[0].geometry.coordinates[1].toPrecision(6).toString() + ', ' + e.features[0].geometry.coordinates[0].toPrecision(6).toString();
                            appuiCible.value.type = e.features[0].properties.TYPE_APPUI
                            appuiCible.value.verif = e.features[0].properties.id || 'origin';
                            isOpenAppui.value = true;
                        }
                    })
                    eventsMapboxAppui.value = true;
                }
                gestionCouches("appuis", showAppuis.value);
                break;
            case 'chambres':
                map.addLayer(
                    {
                        'id': source + '-rosalyna',
                        'type': 'symbol',
                        'source': source,
                        'minzoom': 13,
                        'layout': {
                            'icon-image': 'CHA',
                            'icon-size': 0.25,
                            'text-field': ['get', 'CODE_CH1'],
                            'text-font': [
                                'Open Sans Semibold',
                                'Arial Unicode MS Bold'
                            ],
                            'text-offset': [0, 1.25],
                            'text-anchor': 'top',
                            'text-size': [
                                'case',
                                ['boolean', ['get', 'has_boitier'], false], 18,
                                14
                            ]
                        },
                        'paint': {
                            'text-color': [
                                'case',
                                ['boolean', ['get', 'has_boitier'], false], '#c2410c',
                                '#000'
                            ],
                            'text-halo-color': [
                                'case',
                                ['boolean', ['get', 'has_boitier'], false], '#fed7aa',
                                '#6bdaff'
                            ],
                            'text-halo-width': 1
                        }

                    },
                )
                if (eventsMapboxChambre.value === false) {
                    map.on('click', 'chambres-rosalyna', async function (e: any) {

                        if (nroAnchorPickBlocksPitPopups.value) return;
                        if (e.features && dessinEnCours.value === false && selectionCouche.value === 'chambres') {
                            //console.log(e.features)
                            isLastTokenService();
                            chambreCible.value.chambre = e.features[0].properties.CODE_CH1;
                            chambreCible.value.siren = utilisateurSiren.value;
                            chambreCible.value.adresse = e.features[0].geometry.coordinates;
                            chambreCible.value.codePostal = 'Indisponible';
                            chambreCible.value.ville = 'Indisponible';
                            chambreCible.value.insee = e.features[0].properties.CODE_CH2;
                            chambreCible.value.coord = e.features[0].geometry.coordinates[1].toString() + ', ' + e.features[0].geometry.coordinates[0].toString();

                            //chambreCible.value.coord = e.features[0].geometry.coordinates[1].toPrecision(6).toString() + ', ' + e.features[0].geometry.coordinates[0].toPrecision(6).toString();
                            chambreCible.value.type = e.features[0].properties.REF_CHAMBR
                            chambreCible.value.verif = e.features[0].properties.id || 'origin';
                            isOpenChambre.value = true;
                        }
                    })
                    eventsMapboxChambre.value = true;
                }
                // S'assurer que les chambres restent au-dessus des autres couches techniques
                try {
                    map.moveLayer('chambres-rosalyna');
                } catch (_) {
                    /* ignore */
                }
                break;
            case 'conduites':
                if (infoDevice.platform === 'web') {
                    map.addLayer(
                        {
                            'id': source + '-rosalyna',
                            'type': 'line',
                            'minzoom': 5,
                            'source': 'conduites',
                            'paint': {
                                'line-width': 2,
                                'line-color': [
                                    'match', ['get', 'MODE_POSE'],
                                    '7',
                                    '#74a381',
                                    'rgba(209, 153, 255,0.85)'
                                ]

                            }
                        },
                    )
                } else {
                    map.addLayer(
                        {
                            'id': source + '-rosalyna',
                            'type': 'line',
                            'minzoom': 10,
                            'source': 'conduites',
                            'paint': {
                                'line-width': 2,
                                'line-color': [
                                    'match', ['get', 'MODE_POSE'],
                                    '7',
                                    '#74a381',
                                    'rgba(209, 153, 255,0.85)'
                                ]

                            }
                        },
                    )
                }


                if (eventsMapboxConduite.value === false) {
                    map.on('click', 'conduites-rosalyna', async function (e: any) {
                        if (e.features && dessinEnCours.value === false && selectionCouche.value === 'conduites') {
                            isLastTokenService();
                            if (e.features.length > 1) {
                                const actionSheetPropositions: { text: any; role: any; data: any; }[] = [];

                                e.features.map((conduite: any) => {
                                    const distance_shape_len_ou_lon = conduite.properties.SHAPE_LEN || e.features[0].properties.LONGUEUR;
                                    actionSheetPropositions.push({
                                        text: distance_shape_len_ou_lon + ' - ' + conduite.properties.COMPOSITIO,
                                        role: conduite,
                                        data: conduite,
                                    })
                                })
                                const dataCible = await choixDeConduite(actionSheetPropositions);
                                conduiteCible.value.precision = 'Sans_Commande';
                                conduiteCible.value.siren = utilisateurSiren.value;
                                conduiteCible.value.fci = 'Sans_FCI';
                                conduiteCible.value.composition = dataCible.properties.COMPOSITIO;
                                conduiteCible.value.modepose = dataCible.properties.MODE_POSE;
                                conduiteCible.value.distance = dataCible.properties.SHAPE_LEN;
                                conduiteCible.value.geometry = dataCible.geometry;
                                conduiteCible.value.verif = dataCible.properties.id || 'origin';
                                isOpenConduite.value = true;
                                ajouterSource({ type: 'FeatureCollection', features: [dataCible] }, 'chemin')
                                ajouterCouche('chemin')
                            } else {
                                //console.log(e.features[0])
                                conduiteCible.value.precision = 'Sans_Commande';
                                conduiteCible.value.siren = utilisateurSiren.value;
                                conduiteCible.value.fci = 'Sans_FCI';
                                conduiteCible.value.composition = e.features[0].properties.COMPOSITIO;
                                conduiteCible.value.modepose = e.features[0].properties.MODE_POSE;
                                conduiteCible.value.distance = e.features[0].properties.SHAPE_LEN || e.features[0].properties.LONGUEUR;
                                conduiteCible.value.geometry = e.features[0].geometry;
                                conduiteCible.value.verif = e.features[0].properties.id || 'origin';
                                isOpenConduite.value = true;
                                ajouterSource({ type: 'FeatureCollection', features: e.features }, 'chemin')
                                ajouterCouche('chemin')
                            }

                        }
                    })
                    map.on('mouseenter', 'conduites-rosalyna', () => {
                        map.getCanvas().style.cursor = 'pointer'
                    })
                    map.on('mouseleave', 'conduites-rosalyna', () => {
                        map.getCanvas().style.cursor = ''
                    })
                    eventsMapboxConduite.value = true
                }
                break;
            case 'arcep':
                map.addLayer({
                    'id': source + '-rosalyna',
                    'type': 'symbol',
                    'source': source,
                    'minzoom': 17,
                    'layout': {
                        'icon-image': [
                            'match', ['get', 'type_imb'],
                            'PA', 'PA',   // Image for 'PA'
                            'IM', 'IM',   // Image for 'IM'
                            'PA'    // Default image
                        ],
                        'text-size': 10,
                        'icon-size': 0.15,
                        'text-field': ['get', 'imb_id'],
                        'text-font': [
                            'Open Sans Semibold',
                            'Arial Unicode MS Bold'
                        ],
                        'text-offset': [0, 1.25],
                        'text-anchor': 'top'
                    },
                    'paint': {
                        'text-color': '#000',

                        // Use a "match" expression to set different halo colors based on the 'construction' property
                        'text-halo-color': [
                            'match', ['get', 'construction'],
                            'CONSTRUIT', '#00ff00',   // Green halo for 'construit'
                            'ETUDIE', '#eaff47',       // Blue halo for 'etude'
                            '#47bfff'                 // Default halo color
                        ],
                        'text-halo-width': 1
                    }
                });

                map.addLayer(
                    {
                        'id': 'bloquants-rosalyna',
                        'type': 'symbol',
                        'source': 'bloquants',
                        'layout': {
                            'icon-image': [
                                'match', ['get', 'type'],
                                'immeuble',
                                'PA',
                                'bloquant',
                                'cross',
                                'circle'
                            ],
                            'icon-size': [
                                'match', ['get', 'type'],
                                'immeuble',
                                0.15,
                                'bloquant',
                                0.5,
                                1
                            ],
                            'text-field': ['get', 'label'],
                            'text-font': [
                                'Open Sans Semibold',
                                'Arial Unicode MS Bold'
                            ],

                            'text-offset': [0, 1.25],
                            'text-anchor': 'top',
                        },
                        'paint': {
                            'text-color': '#000',

                            'text-halo-color': [
                                'match', ['get', 'type'],
                                'immeuble',
                                '#6bffbf',
                                'bloquant',
                                '#ff63b4',
                                '#6bffbf'
                            ],
                            'text-halo-width': 1

                        }
                    },
                )
                map.on('contextmenu', 'bloquants-rosalyna', (e) => getdeleleAnnotation(e))

                map.on('click', 'arcep-rosalyna', async function (e: any) {

                    if (e.features && dessinEnCours.value === false) {
                        isLastTokenService();
                        immeubleCible.value.immeuble = e.features[0].properties.imb_id;
                        immeubleCible.value.type_imb = e.features[0].properties.type_imb;
                        immeubleCible.value.siren = utilisateurSiren.value;
                        immeubleCible.value.adresse = e.features[0].properties.num_voie + ' ' + e.features[0].properties.type_voie + ' ' + e.features[0].properties.nom_voie;
                        immeubleCible.value.codePostal = e.features[0].properties.code_poste;
                        immeubleCible.value.ville = e.features[0].properties.nom_com;
                        immeubleCible.value.insee = inseeActif;
                        immeubleCible.value.coord = e.features[0].geometry.coordinates[1].toPrecision(6).toString() + ', ' + e.features[0].geometry.coordinates[0].toPrecision(6).toString();
                        immeubleCible.value.verif = e.features[0].properties.id || 'origin';

                        isOpenImmeuble.value = true;
                    }
                })

                activeLog.value = true;
                gestionCouches("arcep", showLogements.value);


                break;
            case 'annotation-immeuble':
                map.addLayer(
                    {
                        'id': source + '-rosalyna',
                        'type': 'symbol',
                        'source': source,
                        'layout': {
                            'icon-image': [
                                'match', ['get', 'type'],
                                'immeuble',
                                'PA',
                                'bloquant',
                                'cross',
                                'circle'
                            ],
                            'icon-size': [
                                'match', ['get', 'type'],
                                'immeuble',
                                0.15,
                                'bloquant',
                                0.5,
                                1
                            ],
                            'text-field': ['get', 'label'],
                            'text-font': [
                                'Open Sans Semibold',
                                'Arial Unicode MS Bold'
                            ],

                            'text-offset': [0, 1.25],
                            'text-anchor': 'top',
                        },
                        'paint': {
                            'text-color': '#000',

                            'text-halo-color': [
                                'match', ['get', 'type'],
                                'immeuble',
                                '#6bffbf',
                                'bloquant',
                                '#ff63b4',
                                '#6bffbf'
                            ],
                            'text-halo-width': 1

                        }
                    },
                )
                map.on('click', 'annotation-immeuble-rosalyna', (e) => openAnnotation(e))
                map.on('contextmenu', 'annotation-immeuble-rosalyna', (e) => getdeleleAnnotation(e))
                gestionCouches("annotations", showAnnotations.value);
                break;

        }
    } catch (e) {
        //console.log(e)
    }
    if (dessinEnCours.value) {
        raiseDrawLayersOnTop();
    }

}

export const getdeleleAnnotation = async (e: any) => {

    if (e.length > 6 && dessinEnCours.value === false && promptInUse === false) {
        promptInUse = true;
        const id = e;
        const { value } = await Dialog.confirm({
            title: 'Label',
            message: `Souhaitez-vous supprimer l'annotation ${id} ?`,
        });
        if (value) {
            deleteAnnotation(id)
            promptInUse = false;
        } else {
            presentToast("Suppression annulée", 'info');
            promptInUse = false;
        }
    }
    if (e.features && dessinEnCours.value === false && promptInUse === false) {
        promptInUse = true;
        const id = e.features[0].properties.id;
        const { value } = await Dialog.confirm({
            title: 'Label',
            message: `Souhaitez-vous supprimer l'annotation ${id} ?`,
        });
        if (value) {
            deleteAnnotation(id)
            promptInUse = false;
        } else {
            presentToast("Suppression annulée", 'info');
            promptInUse = false;
        }
    }
}

export const getDeleteAppui = async (e: any) => {
    //console.log(e)
    if (e.length > 6 && dessinEnCours.value === false) {
        const id = e;
        const { value } = await Dialog.confirm({
            title: 'Label',
            message: `Souhaitez-vous supprimer l'Appui ${id} ?`,
        });
        if (value) {
            deleteAppui(id)
        } else {
            presentToast("Suppression annulée", 'info');
        }
    }
    if (e.features && dessinEnCours.value === false) {
        const id = e.features[0].properties.id;
        const { value } = await Dialog.confirm({
            title: 'Label',
            message: `Souhaitez-vous supprimer l'Appui ${id} ?`,
        });
        if (value) {
            deleteAppui(id)
        } else {
            presentToast("Suppression annulée", 'info');
        }
    }


}

export const openAnnotation = (e: any) => {
    //console.log(e)
    if (e.features && dessinEnCours.value === false) {
        switch (e.features[0].properties.type) {
            case 'immeuble':
                isLastTokenService();
                immeubleCible.value.immeuble = e.features[0].properties.imb_id;
                immeubleCible.value.siren = utilisateurSiren.value;
                immeubleCible.value.adresse = 'Aucun référencement ARCEP';
                immeubleCible.value.codePostal = '';
                immeubleCible.value.ville = '';
                immeubleCible.value.insee = e.features[0].properties.code_insee;
                immeubleCible.value.coord = parseFloat(e.features[0].properties.y).toPrecision(6).toString() + ', ' + parseFloat(e.features[0].properties.x).toPrecision(6).toString();
                immeubleCible.value.verif = e.features[0].properties.id || 'origin';
                isOpenImmeuble.value = true;
                break;
            case 'bloquant':
                //console.log("annotation bloquant");
                break;
        }

    }
}

function normalizeInseeForPit(raw: unknown): string {
    const code = String(raw ?? '').trim();
    if (!code) return '';
    return code.length === 4 ? `0${code}` : code;
}

function inseeDiskCandidates(insee: string): string[] {
    const code = normalizeInseeForPit(insee);
    if (!code) return [];
    const stripped = code.replace(/^0+/, '') || code;
    return [...new Set([code, stripped, stripped.padStart(5, '0')])];
}

/** INSEE dont le PIT (conduite) est présent en local. */
export async function resolvePitInseeOnDisk(insee: string): Promise<string | null> {
    for (const candidate of inseeDiskCandidates(insee)) {
        if (await isOnDisk(candidate, 'conduite')) {
            return candidate;
        }
    }
    return null;
}

/**
 * Charge le PIT d'une commune si disponible sur le disque ;
 * sinon ouvre le modal de téléchargement.
 */
export async function ensurePitLoadedForInsee(
    insee: string,
    options: {
        dezoom?: boolean;
        openDownloadIfMissing?: boolean;
        reason?: string;
    } = {}
): Promise<boolean> {
    const {
        dezoom = false,
        openDownloadIfMissing = true,
        reason = '',
    } = options;

    const diskInsee = await resolvePitInseeOnDisk(insee);
    if (!diskInsee) {
        if (openDownloadIfMissing) {
            const code = normalizeInseeForPit(insee) || String(insee);
            majPIT(
                code,
                reason ||
                    `Téléchargez le PIT de la commune (${code}) pour les appuis et chambres.`
            );
        }
        return false;
    }

    const activeCandidates = inseeActif
        ? inseeDiskCandidates(inseeActif)
        : [];
    const alreadyLoaded =
        activeCandidates.includes(diskInsee) && !!map?.getSource('appuis');

    if (!alreadyLoaded) {
        await chargeruneville(diskInsee, false, dezoom);
    }

    return true;
}

export const isOnDisk = async (insee: string, type: any) => {
    try {
        const contents = await Filesystem.readFile({
            path: `${type}_${insee}.geojson`,
            directory: folderCapacitor.value,
            encoding: Encoding.UTF8,
        });
        const data = await toStringData(contents.data);
        try {
            const json = JSON.parse(data);
            const features = Array.isArray(json?.features) ? json.features : [];
            // On considère le PIT présent si le fichier existe et contient au moins 1 feature
            return features.length > 0;
        } catch {
            // Fallback simple : fichier présent mais non parsable, on le considère absent
            return false;
        }
    } catch {
        return false;
    }
}

export const chargerImmeuble = () => {
    //console.log(immeubleCible.value)
    return immeubleCible
}

export const chargerChambre = () => {
    //console.log(chambreCible.value)
    return chambreCible
}

export const chargerConduite = () => {
    //console.log(chambreCible.value)
    return conduiteCible
}

export const chargerAppui = () => {
    //console.log(appuiCible.value)
    return appuiCible
}

export const defineCible = async (features: any) => {
    immeubleCible.value.immeuble = features[0].properties.imb_id;
    immeubleCible.value.siren = await getUserSiren();
    immeubleCible.value.adresse = features[0].properties.num_voie + ' ' + features[0].properties.type_voie + ' ' + features[0].properties.nom_voie;
    immeubleCible.value.adresse = immeubleCible.value.adresse.replaceAll('undefined', '');
    immeubleCible.value.codePostal = features[0].properties.code_poste;
    immeubleCible.value.ville = features[0].properties.nom_com;
    immeubleCible.value.insee = features[0].properties.code_insee;
    immeubleCible.value.coord = features[0].properties.y.toPrecision(6).toString() + ', ' + features[0].properties.x.toPrecision(6).toString();
    return immeubleCible
}

/*export const listDesInsee = (input: any) => {
    /*
        {
        "COM": "01001",
        "DEP": "01",
        "NCC": "ABERGEMENT CLEMENCIAT"
        }
    
    const res_text = datagouv.filter((point_technique) =>
        point_technique.NCC.toLowerCase().includes(input.toLowerCase())
    ).slice(0, 5);
    const res_inse = datagouv.filter((point_technique) =>
        point_technique.COM.toString().includes(input.toLowerCase())
    ).slice(0, 5);

    if (res_text.length > 0) {
        return res_text
    } else {
        return res_inse
    }
}*/

export const listDesInsee = (input: string) => {
    const inputLower = input.toLowerCase();

    const res_text = datagouv.filter((point_technique) =>
        point_technique.NCC.toString().toLowerCase().includes(inputLower)
    );

    const res_inse = datagouv.filter((point_technique) =>
        point_technique.COM.toString().toLowerCase().includes(inputLower)
    );

    // Priorité aux résultats texte, sinon code insee
    if (res_text.length > 0) {
        return res_text.slice(0, 5);
    } else {
        return res_inse.slice(0, 5);
    }
}


export const chargeruneville = async (insee: any, type: any, dezoom = true) => {
    inseeAffiche.value = insee;
    console.log('token Check')
    const stateToken = await isLastTokenService();
    if (stateToken) {
        let isAvailable = true;
        projetActif = '';
        inseeActif = insee;
        const typesFiles = ['conduite', 'appui', 'chambre', 'arcep', 'cadastre_batiments', 'cadastre_parcelles', 'commune_tampon'];
        const statFile = await Filesystem.readFile({
            path: `appui_${insee}.geojson`,
            directory: folderCapacitor.value,
            encoding: Encoding.UTF8,
        }).catch((err) => {
            if (err?.message?.includes('exist')) {
                isAvailable = false;
                showConfirm(insee, `Le module ${type} n'est pas disponible.`, true);
                return;
            }
            if (err?.message?.includes('latitude')) {
                presentToast("Les coordonnées doivent être en WGS84:4326. Contactez votre CA.", 'info');
            }
        });
        if (isAvailable) {
            presentToast("Chargement dans la cartographie", 'info');
            for (const typeFile of typesFiles) {
                try {
                    const contents = await Filesystem.readFile({
                        path: `${typeFile}_${insee}.geojson`,
                        directory: folderCapacitor.value,
                        encoding: Encoding.UTF8,
                    });
                    const data = await toStringData(contents.data);
                    if (data.trim().startsWith('<')) {
                        presentToast(`Le fichier ${typeFile} est invalide ou indisponible`, 'warning-outline');
                        continue;
                    }
                    let geojson;
                    try {
                        geojson = JSON.parse(data);
                    } catch (err) {
                        presentToast(`Le fichier ${typeFile} est invalide ou indisponible`, 'warning-outline');
                        continue;
                    }
                    switch (typeFile) {
                        case 'appui':
                            appuisActif = geojson;
                            try {
                                await ajouterSource(geojson, 'appuis');
                                ajouterCouche('appuis');
                            } catch (e) {
                                console.error('[chargeruneville] layer appuis', e);
                            }
                            break;
                        case 'chambre':
                            chambresActif = geojson;
                            try {
                                await ajouterSource(geojson, 'chambres');
                                ajouterCouche('chambres');
                            } catch (e) {
                                console.error('[chargeruneville] layer chambres', e);
                            }
                            break;
                        case 'conduite':
                            try {
                                await ajouterSource(geojson, 'conduites', dezoom);
                                ajouterCouche('conduites');
                            } catch (e) {
                                console.log(e);
                            }
                            break;
                        case 'arcep':
                            immeubleActif = geojson;
                            try {
                                await ajouterSource(geojson, 'arcep');
                                ajouterCouche('arcep');
                            } catch (e) {
                                console.error('[chargeruneville] layer arcep', e);
                            }
                            break;
                        case 'cadastre_batiments':
                            batimentActif = geojson;
                            try {
                                await ajouterSource(geojson, 'batiment');
                                ajouterCouche('batiment');
                            } catch (e) {
                                console.error('[chargeruneville] layer batiment', e);
                            }
                            break;
                        case 'cadastre_parcelles':
                            parcelleActif = geojson;
                            try {
                                await ajouterSource(geojson, 'parcelle');
                                ajouterCouche('parcelle');
                            } catch (e) {
                                console.error('[chargeruneville] layer parcelle', e);
                            }
                            break;
                        case 'commune_tampon':
                            try {
                                await ajouterSource(geojson, 'commune_tampon');
                                ajouterCouche('commune_tampon');
                            } catch (e) {
                                console.error('[chargeruneville] layer commune_tampon', e);
                            }
                            break;
                    }
                } catch (err: any) {
                    if (err?.message?.includes("exist")) {
                        // fichier manquant : on passe
                        continue;
                    }
                    console.error("[chargeruneville] read error", typeFile, err);
                }
            }

        }
    }

}

/** Liste complete des NRO (etudes) accessibles, regroupees par nom d'etude. */
export const fetchListeNRO = async (): Promise<EtudeNroGroupe[]> => {
    const res = await fetch(`${prodEnvironment.baseUrl}api/etudes`, {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error(`Impossible de charger les NRO (HTTP ${res.status})`);
    }
    const data = (await res.json()) as etude[];
    const rows = Array.isArray(data) ? data : [];
    listeNRO.value = groupEtudesParNro(rows);
    return listeNRO.value;
}

export const downloadPIT = async (insee: any) => {

    const typesFiles = ['appui', 'chambre', 'arcep', 'conduite', 'pbo', 'cable', 'mediapost', 'cadastre_batiments', 'cadastre_parcelles', 'commune_tampon'];
    for (const typeFile of typesFiles) {
        try {
            showLoading(`Téléchargement couche ${typeFile} en cours...`, 2000);
            const url = `${prodEnvironment.baseUrl}api/data/${typeFile}/${insee}`;
            const res = await fetch(url, { credentials: 'include' });
            const da = await res.text();
            await Filesystem.writeFile({
                path: `${typeFile}_${insee}.geojson`,
                data: da,
                directory: folderCapacitor.value,
                encoding: Encoding.UTF8,
                recursive: true
            });
            if (typeFile == 'conduite' && da.includes('"vid"')) {
                presentToast(`Le PIT n'est pas disponible.`, 'info');
            }
        } catch (e) {
            presentToast(`Echec telechargement ${typeFile} ${insee}`, 'warning-outline');
        }
    }
    presentToast(`Sauvegarde du PIT`, 'info');
    listDesInsee(input.value)
}

export const mapLeave = () => {
    mapLeft.value = true;
}

// Ajoute un PIT supplémentaire sur la carte sans remplacer les données en place
export const appendPitToMap = async (insee: string, dezoom = false) => {
    const typesFiles = ['conduite', 'appui', 'chambre', 'arcep', 'cadastre_batiments', 'cadastre_parcelles', 'commune_tampon'];
    for (const typeFile of typesFiles) {
        try {
            const contents = await Filesystem.readFile({
                path: `${typeFile}_${insee}.geojson`,
                directory: folderCapacitor.value,
                encoding: Encoding.UTF8,
            });
            const data = await toStringData(contents.data);
            if (data.trim().startsWith('<')) {
                presentToast(`Le fichier ${typeFile} est invalide ou indisponible`, 'warning-outline');
                continue;
            }
            const geojson = JSON.parse(data);
            if (!geojson?.features) {
                presentToast(`Le fichier ${typeFile} est invalide ou vide`, 'warning-outline');
                continue;
            }

            const mergeCollections = (base: any, addition: any) => {
                if (!base || !base.features) return addition;
                return { ...base, features: [...base.features, ...(addition?.features || [])] };
            };

            const updateSource = async (sourceName: string, collection: any, addLayer = true) => {
                if (map.getSource(sourceName)) {
                    (map.getSource(sourceName) as mapboxgl.GeoJSONSource).setData(collection);
                } else {
                    await ajouterSource(collection, sourceName, dezoom);
                    if (addLayer) ajouterCouche(sourceName);
                }
            };

            switch (typeFile) {
                case 'appui':
                    appuisActif = mergeCollections(appuisActif, geojson);
                    await updateSource('appuis', appuisActif);
                    break;
                case 'chambre':
                    chambresActif = mergeCollections(chambresActif, geojson);
                    await updateSource('chambres', chambresActif);
                    break;
                case 'conduite':
                    conduiteActif = mergeCollections(conduiteActif, geojson);
                    await updateSource('conduites', conduiteActif);
                    break;
                case 'arcep':
                    immeubleActif = mergeCollections(immeubleActif, geojson);
                    await updateSource('arcep', immeubleActif);
                    break;
                case 'cadastre_batiments':
                    batimentActif = mergeCollections(batimentActif, geojson);
                    await updateSource('batiment', batimentActif);
                    break;
                case 'cadastre_parcelles':
                    parcelleActif = mergeCollections(parcelleActif, geojson);
                    await updateSource('parcelle', parcelleActif);
                    break;
                case 'commune_tampon':
                    communeTamponTitre.value = "Chargé";
                    await updateSource('commune_tampon', geojson);
                    break;
            }
        } catch (err: any) {
            if (err?.message?.includes('exist')) {
                presentToast(`Le module ${typeFile} n'est pas disponible pour ${insee}`, 'warning-outline');
            }
        }
    }
}


export const showConfirm = async (insee: any, message: any, ddl: any) => {
    if (ddl) {
        majPIT(insee, "Le PIT de votre commande n'etait pas disponible.");
    } else {
        const { value } = await Dialog.confirm({
            title: 'Attention',
            message: `${message}`,
        });
    }
};

export const volerVers = (geometry: any, zoom = 20) => {
    const arr = geometry.split(',');


    map.flyTo({
        center: [arr[1], arr[0]],
        zoom: zoom,
        pitch: 0,
        essential: true
    });

    const screenCoor = map.project([arr[1], arr[0]]);
    //console.log(arr[1], arr[0])
    //console.log(screenCoor.x, screenCoor.y)
    const hapticsImpactMedium = async () => {
        await Haptics.impact({ style: ImpactStyle.Medium });
    };
}


/**
 * Calcule le point "milieu" entre plusieurs coordonnées.
 * @param coords Tableau de coordonnées [longitude, latitude]
 * @returns [longitude, latitude] du centre calculé
 */
export const getGeographicMidpoint = (coords: [number, number][]): [number, number] => {
    if (!coords || coords.length === 0) {
        throw new Error('Le tableau de coordonnées est vide.');
    }

    // Cas 1 — un seul point
    if (coords.length === 1) return coords[0];

    // Cas 2 — polygone (premier = dernier)
    const isClosedPolygon =
        coords.length > 3 &&
        coords[0][0] === coords[coords.length - 1][0] &&
        coords[0][1] === coords[coords.length - 1][1];

    if (isClosedPolygon) {
        const polygon = turf.polygon([coords]);
        const center = turf.centerOfMass(polygon);
        return center.geometry.coordinates as [number, number];
    }

    // Cas 3 — ligne (au moins 2 points)
    if (coords.length >= 2) {
        const line = turf.lineString(coords);
        const total = turf.length(line, { units: 'kilometers' });
        const midpoint = turf.along(line, total / 2, { units: 'kilometers' });
        return midpoint.geometry.coordinates as [number, number];
    }

    // Cas par défaut — centre arithmétique
    const n = coords.length;
    const sum = coords.reduce(
        (acc, [lng, lat]) => {
            acc.lng += lng;
            acc.lat += lat;
            return acc;
        },
        { lng: 0, lat: 0 }
    );
    return [sum.lng / n, sum.lat / n];
}

// export const volerVersDeuxPoints = (coord1: any, coord2: any) => {
//     // récupérer les coordonnées des deux points
//     // trouver le centre entre les deux points
//     // voler vers ce centre avec un flyTo
//     //Disclaimer : cette fonction ne gère pas les cas où les points sont très éloignés (ex: traversée de l'Atlantique)
// }



export const gestionCadastre = (source: string, nouvelEtat: boolean) => {
    if (!hasSource(source)) return;
    if (nouvelEtat) {
        if (hasLayer(source + '-rosalyna1')) map.setLayoutProperty(source + '-rosalyna1', 'visibility', 'visible');
        if (hasLayer(source + '-rosalyna2')) map.setLayoutProperty(source + '-rosalyna2', 'visibility', 'visible');
        if (hasLayer('titre-parcelle')) map.setLayoutProperty('titre-parcelle', 'visibility', 'visible');
    } else {
        if (hasLayer(source + '-rosalyna1')) map.setLayoutProperty(source + '-rosalyna1', 'visibility', 'none');
        if (hasLayer(source + '-rosalyna2')) map.setLayoutProperty(source + '-rosalyna2', 'visibility', 'none');
        if (hasLayer('titre-parcelle')) map.setLayoutProperty('titre-parcelle', 'visibility', 'none');
    }
}

export const gestionCouches = (source: string, nouvelEtat: boolean) => {
    if (!map.getSource(source)) return;
    const vis = nouvelEtat ? 'visible' : 'none';
    const mainId = source + '-rosalyna';
    if (hasLayer(mainId)) {
        map.setLayoutProperty(mainId, 'visibility', vis);
    }
    const labelId = source + '-rosalyna-label';
    if (hasLayer(labelId)) {
        map.setLayoutProperty(labelId, 'visibility', vis);
    }
}

export const gestionFonds = (source: string, nouvelEtat: boolean) => {
    if (source == "satellite" && nouvelEtat) {
        const textColor = '#ffffff';
        map.setPaintProperty('chambres-rosalyna', 'text-color', [
            'case',
            ['boolean', ['get', 'has_boitier'], false], '#c2410c',
            textColor
        ]);
        map.setPaintProperty('appuis-rosalyna', 'text-color', textColor);
        map.setPaintProperty('arcep-rosalyna', 'text-color', textColor);
        map.setPaintProperty('etude_noeud-rosalyna', 'text-color', textColor);
        map.setLayoutProperty('road-street', 'visibility', 'none');
    }
    if (source == "satellite" && !nouvelEtat) {
        const textColor = '#000';
        map.setPaintProperty('chambres-rosalyna', 'text-color', [
            'case',
            ['boolean', ['get', 'has_boitier'], false], '#c2410c',
            textColor
        ]);
        map.setPaintProperty('appuis-rosalyna', 'text-color', textColor);
        map.setPaintProperty('arcep-rosalyna', 'text-color', textColor);
        map.setPaintProperty('etude_noeud-rosalyna', 'text-color', textColor);
        map.setLayoutProperty('road-street', 'visibility', 'visible');
    }
    if (nouvelEtat) {
        map.setLayoutProperty(source, 'visibility', 'visible');

    } else { map.setLayoutProperty(source, 'visibility', 'none'); }
}

export const getAddressFromCoordinates = async (
    coordinates: [number, number],
    options?: { language?: string }
) => {
    const [lon, lat] = coordinates;
    if (!Number.isFinite(lon) || !Number.isFinite(lat)) return "";
    const lang = options?.language ? `&language=${encodeURIComponent(options.language)}` : "";
    try {
        const response = await fetch(
            `https://api.mapbox.com/geocoding/v5/mapbox.places/${lon},${lat}.json?access_token=${accessToken}&limit=1${lang}`
        );
        if (!response.ok) return "";
        const data = await response.json();
        return data?.features?.[0]?.place_name ? String(data.features[0].place_name) : "";
    } catch (error) {
        console.error("Error fetching address:", error);
        return "";
    }
};

export async function chambresByNumber(number: string | number) {
    //console.log(number);

    //     return chambresActif.filter((point_technique :any ) =>
    //     point_technique.properties.CODE_CH1.toLowerCase().includes(input.value.toLowerCase())
    //   ).slice(0, 5);
    //console.log(await chambresActif)
    return 0;
}

const updateOrAddSource = async (name: string, data: any, addLayer = true, dezoom = true) => {
    const src = map.getSource(name) as mapboxgl.GeoJSONSource | undefined;
    if (src) {
        console.log(`[updateOrAddSource] setData ${name}`);
        src.setData(data);
    } else {
        console.log(`[updateOrAddSource] addSource ${name}`);
        await ajouterSource(data, name, dezoom);
        if (addLayer) ajouterCouche(name);
    }
};

export async function chargerCommande(
    precision: any,
    fci: any,
    insee?: string,
    commandeId?: string
) {
    console.log("[chargerCommande] start", { precision, fci, commandeId });
    await updateOrAddSource('chambres', chambresActif);

    tableauCommande.value = [];
    gcbloFeatures = [];

    const precisionSafe = encodeURIComponent(precision);
    const fciSafe = fci ? `/${encodeURIComponent(fci)}` : '';
    const isValidObjectId = typeof commandeId === 'string' && /^[0-9a-fA-F]{24}$/.test(commandeId);
    const url = isValidObjectId
        ? `${prodEnvironment.baseUrl}api/gcblo/get/commande/id/${commandeId}`
        : `${prodEnvironment.baseUrl}api/gcblo/get/commande/${precisionSafe}${fciSafe}`;

    const response = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
            'Content-Type': 'application/json',
        },
    })
    if (!response.ok) return;
    let jsonPayload: any;
    try {
        jsonPayload = await response.json();
    } catch (err) {
        return;
    }
    const mappedCommandes = (jsonPayload || []).map((commande: any, idx: number) => {
        const diam =
            parseFloat(commande?.diametre) ||
            parseFloat(commande?.diameter) ||
            parseFloat(commande?.type_cable_capacite) ||
            parseFloat(commande?.capacite);
        const diamNum = Number.isFinite(diam) ? diam : undefined;
        const props = {
            ...(commande.properties || {}),
            diametre_num: diamNum,
            offset_idx: 0,
        };
        if (commande.type_cable_capacite && props.type_cable_capacite === undefined) {
            props.type_cable_capacite = commande.type_cable_capacite;
        }
        if (!commande.properties && commande.diametre_num !== undefined) {
            props.diametre_num = commande.diametre_num;
        }
        return {
            ...commande,
            properties: props,
        };
    });
    tableauCommande.value = mappedCommandes;
    nomCommande.value = precision;
    fciCommande.value = fci;
    currentCommand.value = { precision, fci, id: isValidObjectId ? commandeId : undefined };



    await markChambresBoitiers(tableauCommande.value);



    const geojson_commande: GeoJSON.FeatureCollection = {
        "type": "FeatureCollection",
        "features": tableauCommande.value
    }
    const geojsonCoor = []

    gcbloFeatures = [...geojson_commande.features];

    const gcbloSource = map.getSource('gcblo') as mapboxgl.GeoJSONSource | undefined;
    const merged: GeoJSON.FeatureCollection = {
        type: 'FeatureCollection',
        features: gcbloFeatures
    };
    tableauCommande.value = merged.features as any;
    if (gcbloSource) {
        gcbloSource.setData(merged);
    } else {
        await ajouterSource(merged, 'gcblo');
        ajouterCouche('gcblo');
    }
    applyGcbloStyle(cablesByDiameter.value);

    //TODO ajouter sources et couches du pit mis a jour
    // markChambresBoitiers already updates the source, no-op here

    const bbox = turf.bbox({
        type: 'FeatureCollection',
        features: tableauCommande.value
    });

    //dans la création des cables rapides (entre autres) on se replace la section crée
    // et non sur la commande entière
    if (midpoint) {
        // console.log('voler vers midpoint', midpoint);
        volerVers(midpoint.toString(), 16);
        midpoint = null;
    }
    else {
        //map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]]);
        fitBoundsAsync(map, [[bbox[0], bbox[1]], [bbox[2], bbox[3]]]);
        geocoder.setBbox([bbox[0], bbox[1], bbox[2], bbox[3]])
    }

}



export const percementAnticipe = (objet: any, nomChambre: any, insee: any, fci = "F00000jjmmaa") => {
    const codeFinal = insee + '-' + nomChambre;
    const nouvelle_commune = datagouv.filter((point_technique) => point_technique.COM == inseeActif).slice(0, 1);
    const url = prodEnvironment.baseUrl + "api/gcblo/export/percement/" + codeFinal + "/" + nouvelle_commune[0] + "/" + fci;
    window.open(url, "_blank");
}

export const nouveauMarqueur = (objet: { lat?: number; lng?: number }, type_annot: string, ready?: boolean) => {
    if (!map) {
        void presentToast('Carte non prête', 'warning-outline');
        return;
    }
    if (ready === false) {
        void presentToast('Chargement de la chambre en cours…', 'warning-outline');
        return;
    }

    const lat = Number(objet?.lat);
    const lng = Number(objet?.lng);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        void presentToast('Coordonnées chambre invalides', 'warning-outline');
        return;
    }

    ensureMarqueurLayers();

    const sourceId: MarqueurSourceId | null =
        type_annot === 'fleche'
            ? 'marqueurs_fleches'
            : type_annot === 'rose'
              ? 'marqueurs'
              : type_annot === 'croix'
                ? 'marqueurs_croix'
                : null;

    if (!sourceId) {
        void presentToast('Type de marqueur inconnu', 'warning-outline');
        return;
    }

    const newMarker: GeoJSON.Feature = {
        type: 'Feature',
        properties: {
            type: type_annot,
            id: Math.floor(Math.random() * 10000000000),
        },
        geometry: {
            type: 'Point',
            coordinates: [lng, lat],
        },
    };

    marqueurCollections[sourceId].push(newMarker);
    syncMarqueurSource(sourceId);
    raiseMarqueurLayersOnTop();
}

const alternatingOffsetIndex = (idx: number) => {
    // Premier câble non centré : on commence à +/-1, puis on alterne avec amplitude croissante
    const magnitude = Math.floor(idx / 2) + 1;
    const sign = idx % 2 === 0 ? 1 : -1;
    return magnitude * sign;
};

const keyPoint = (coord: CoordPair, precision: number) => {
    const n0 = Number(coord[0]) || 0;
    const n1 = Number(coord[1]) || 0;
    return `${n0.toFixed(precision)},${n1.toFixed(precision)}`;
};

const getLineEndpoints = (geom: GeoJSON.LineString | GeoJSON.MultiLineString): { start: CoordPair; end: CoordPair } | null => {
    if (geom.type === 'LineString') {
        const coords = geom.coordinates as CoordPair[];
        if (!coords.length) return null;
        return { start: coords[0], end: coords[coords.length - 1] };
    }
    const parts = geom.coordinates as CoordPair[][];
    if (!parts.length) return null;
    let start: CoordPair | null = null;
    for (const part of parts) {
        if (part.length) {
            start = part[0] as CoordPair;
            break;
        }
    }
    if (!start) return null;
    let end: CoordPair | null = null;
    for (let i = parts.length - 1; i >= 0; i--) {
        const part = parts[i];
        if (part.length) {
            end = part[part.length - 1] as CoordPair;
            break;
        }
    }
    if (!end) return null;
    return { start, end };
};

const buildEndpointKey = (
    geom: GeoJSON.LineString | GeoJSON.MultiLineString,
    precision: number,
    ignoreDirection: boolean
) => {
    const endpoints = getLineEndpoints(geom);
    if (!endpoints) return null;
    const startKey = keyPoint(endpoints.start, precision);
    const endKey = keyPoint(endpoints.end, precision);
    if (!ignoreDirection || startKey <= endKey) {
        return `${startKey}|${endKey}`;
    }
    return `${endKey}|${startKey}`;
};

// Helpers offset géométrique (décale la ligne en gardant les extrémités)
type CoordPair = [number, number];
const RADIUS = 6378137;
const projectToMercator = ([lng, lat]: CoordPair): CoordPair => {
    const x = (lng * Math.PI * RADIUS) / 180;
    const y = Math.log(Math.tan(Math.PI / 4 + (lat * Math.PI) / 360)) * RADIUS;
    return [x, y];
};
const unprojectFromMercator = ([x, y]: CoordPair): CoordPair => {
    const lng = (x / RADIUS) * (180 / Math.PI);
    const lat = (2 * Math.atan(Math.exp(y / RADIUS)) - Math.PI / 2) * (180 / Math.PI);
    return [lng, lat];
};

const offsetLineString = (coords: CoordPair[], offsetMeters: number): CoordPair[] => {
    if (!coords.length || offsetMeters === 0) return coords;
    if (coords.length === 1) return coords;
    const projected = coords.map(projectToMercator);
    const normals: CoordPair[] = [];
    for (let i = 0; i < projected.length - 1; i++) {
        const [x1, y1] = projected[i];
        const [x2, y2] = projected[i + 1];
        const dx = x2 - x1;
        const dy = y2 - y1;
        const len = Math.hypot(dx, dy);
        if (len === 0) {
            normals.push([0, 0]);
            continue;
        }
        const nx = -dy / len;
        const ny = dx / len;
        normals.push([nx, ny]);
    }
    const out: CoordPair[] = [];
    out.push(coords[0]); // garder la première coordonnée
    for (let i = 1; i < projected.length - 1; i++) {
        const prev = normals[i - 1] || [0, 0];
        const next = normals[i] || [0, 0];
        const nx = prev[0] + next[0];
        const ny = prev[1] + next[1];
        const nlen = Math.hypot(nx, ny) || 1;
        const ox = projected[i][0] + (nx / nlen) * offsetMeters;
        const oy = projected[i][1] + (ny / nlen) * offsetMeters;
        out.push(unprojectFromMercator([ox, oy]));
    }
    out.push(coords[coords.length - 1]); // garder la dernière coordonnée
    return out;
};

const offsetGeometry = (geom: GeoJSON.LineString | GeoJSON.MultiLineString, offsetMeters: number) => {
    if (offsetMeters === 0) return geom;
    if (geom.type === 'LineString') {
        return {
            type: 'LineString',
            coordinates: offsetLineString(geom.coordinates as CoordPair[], offsetMeters),
        } as GeoJSON.LineString;
    }
    const parts = (geom.coordinates as CoordPair[][]).map((part) => offsetLineString(part, offsetMeters));
    return {
        type: 'MultiLineString',
        coordinates: parts,
    } as GeoJSON.MultiLineString;
};

// Génère un label condensé par groupe (diametre/type -> count) et l'applique sur les features
const capacityLabel = (props: any) => {
    // Utilise la logique existante pour déterminer la capacité FO
    const diamRaw = props?.diametre_num ?? props?.diametre ?? null;
    const diamStr = diamRaw != null ? String(diamRaw) : null;
    const cap =
        ingenierieCapacitePourPose(diamStr, props?.alveole ?? props?.modepose) ||
        props?.type_cable_capacite ||
        props?.ca_capacit ||
        props?.type_cable ||
        props?.capacite;
    if (cap != null && cap !== "") return `${cap}Fo`;
    return "?Fo";
};

const updateGcbloLabels = (precision = 5) => {
    const groups = new Map<string, Map<string, number>>();
    gcbloFeatures.forEach((f) => {
        const geom = f.geometry as GeoJSON.LineString | GeoJSON.MultiLineString;
        if (!geom) return;
        const key = buildEndpointKey(geom, precision, true);
        if (!key) return;
        const props: any = f.properties || {};
        const labelKey = capacityLabel(props);
        if (!groups.has(key)) groups.set(key, new Map());
        const g = groups.get(key)!;
        g.set(labelKey, (g.get(labelKey) || 0) + 1);
    });

    gcbloFeatures.forEach((f) => {
        const geom = f.geometry as GeoJSON.LineString | GeoJSON.MultiLineString;
        if (!geom) return;
        const key = buildEndpointKey(geom, precision, true);
        if (!key) return;
        const bucket = groups.get(key);
        if (!bucket || !bucket.size) return;
        const parts = Array.from(bucket.entries())
            .sort((a, b) => (parseFloat(b[0]) || 0) - (parseFloat(a[0]) || 0))
            .map(([k, cnt]) => `${k}(${cnt})`);
        const label = parts.join(" · ");
        if (!f.properties) f.properties = {};
        (f.properties as any).label_gcblo = label;
    });
};

// Rafraîchit les labels et met à jour la source dédiée (indépendant du style)
export const refreshGcbloLabels = (precision = 5) => {
    updateGcbloLabels(precision);
    if (!map) return;
    const baseGeojson: GeoJSON.FeatureCollection = { type: 'FeatureCollection', features: gcbloFeatures };
    const labelSource = map.getSource('gcblo-labels') as mapboxgl.GeoJSONSource | undefined;
    if (labelSource) {
        labelSource.setData(baseGeojson);
    } else if (map.getSource('gcblo')) {
        map.addSource('gcblo-labels', { type: 'geojson', data: baseGeojson });
    }
};

const resetGcbloFeatureOffset = (feature?: GeoJSON.Feature): boolean => {
    if (!feature || !feature.properties) return false;
    const props = feature.properties as Record<string, any>;
    let mutated = false;
    if ('offset_idx' in props) {
        delete props.offset_idx;
        mutated = true;
    }
    if ('offset_group_size' in props) {
        delete props.offset_group_size;
        mutated = true;
    }
    if ('offset_group_index' in props) {
        delete props.offset_group_index;
        mutated = true;
    }
    return mutated;
};

const ensureGcbloOverlapOffsets = (precision = 5, ignoreDirection = true) => {
    if (!map || !gcbloFeatures.length) return;
    const groups = new Map<string, number[]>();
    gcbloFeatures.forEach((feature, idx) => {
        const geom = feature.geometry;
        if (!geom || (geom.type !== 'LineString' && geom.type !== 'MultiLineString')) return;
        const key = buildEndpointKey(geom, precision, ignoreDirection);
        if (!key) return;
        const arr = groups.get(key);
        if (arr) {
            arr.push(idx);
        } else {
            groups.set(key, [idx]);
        }
    });

    const touched = new Set<number>();
    let mutated = false;

    groups.forEach((indices) => {
        if (!indices.length) return;
        indices.forEach((featureIndex, idxInGroup) => {
            touched.add(featureIndex);
            const feature = gcbloFeatures[featureIndex];
            if (!feature) return;
            const props = (feature.properties || {}) as Record<string, any>;
            if (!feature.properties) feature.properties = props;
            // Même seul, on applique un offset pour éviter l'effet bloc
            const nextVal = alternatingOffsetIndex(idxInGroup);
            if (
                props.offset_idx === nextVal &&
                props.offset_group_size === indices.length &&
                props.offset_group_index === idxInGroup
            ) {
                return;
            }
            props.offset_idx = nextVal;
            props.offset_group_size = indices.length;
            props.offset_group_index = idxInGroup;
            mutated = true;
        });
    });

    gcbloFeatures.forEach((feature, idx) => {
        if (!touched.has(idx)) {
            mutated = resetGcbloFeatureOffset(feature) || mutated;
        }
    });

    if (!mutated) return;
    const source = map.getSource('gcblo') as mapboxgl.GeoJSONSource | undefined;
    if (source) {
        const geojson: GeoJSON.FeatureCollection = {
            type: 'FeatureCollection',
            features: gcbloFeatures,
        };
        source.setData(geojson);
    }
};

export const applyGcbloStyle = (byDiameter?: boolean) => {
    // Offsets/couleurs par diamètre désactivés pour le moment
    const mode = false;
    cablesByDiameter.value = false;

    const hasMap = !!map;
    const hasSource = hasMap && !!map.getSource('gcblo');
    const hasLayer = hasMap && !!map.getLayer('gcblo-rosalyna');
    console.log("[applyGcbloStyle] start (disabled by default)", { requested: byDiameter, mode, hasMap, hasSource, hasLayer });
    if (!map) return;
    // Prépare les GeoJSON base/offset
    const baseGeojson: GeoJSON.FeatureCollection = { type: 'FeatureCollection', features: gcbloFeatures };
    const baseOffsetMeters = 2; // écart de base en mètres par pas d'offset_idx
    const offsetFeatures: GeoJSON.Feature[] = mode
        ? gcbloFeatures.map((f) => {
            const props: any = f?.properties || {};
            const idx = Number(props.offset_idx || 0);
            const dist = baseOffsetMeters * idx;
            if (!dist) return f;
            const geom = f.geometry as GeoJSON.LineString | GeoJSON.MultiLineString;
            const newGeom = offsetGeometry(geom, dist);
            return { ...f, geometry: newGeom };
        })
        : gcbloFeatures;
    const offsetGeojson: GeoJSON.FeatureCollection = { type: 'FeatureCollection', features: offsetFeatures };

    // Crée les sources
    const baseSource = map.getSource('gcblo') as mapboxgl.GeoJSONSource | undefined;
    if (baseSource) {
        baseSource.setData(baseGeojson);
    }
    const offsetSource = map.getSource('gcblo-offset') as mapboxgl.GeoJSONSource | undefined;
    if (offsetSource) {
        offsetSource.setData(offsetGeojson);
    } else if (map.getSource('gcblo')) {
        map.addSource('gcblo-offset', { type: 'geojson', data: offsetGeojson });
    }
    const labelSource = map.getSource('gcblo-labels') as mapboxgl.GeoJSONSource | undefined;
    if (labelSource) {
        labelSource.setData(baseGeojson);
    } else if (map.getSource('gcblo')) {
        map.addSource('gcblo-labels', { type: 'geojson', data: baseGeojson });
    }

    // Crée les couches si la source existe mais que les couches ont été supprimées ou pas encore ajoutées
    if (map.getSource('gcblo') && !map.getLayer('gcblo-rosalyna-base')) {
        try {
            map.addLayer({
                id: 'gcblo-rosalyna-base',
                type: 'line',
                source: 'gcblo',
                paint: {
                    'line-width': 2,
                    'line-color': '#00faaf',
                    'line-opacity': 0.8
                },
                layout: {
                    'line-cap': 'round',
                    'line-join': 'round'
                }
            });
        } catch (e) {
            console.error('[applyGcbloStyle] addLayer base failed', e);
        }
    }
    if (map.getSource('gcblo-offset') && !map.getLayer('gcblo-rosalyna')) {
        try {
            map.addLayer({
                id: 'gcblo-rosalyna',
                type: 'line',
                source: 'gcblo-offset',
                paint: {
                    'line-width': 4,
                    'line-color': '#00faaf',
                    'line-opacity': 1
                },
                layout: {
                    'line-cap': 'round',
                    'line-join': 'round'
                }
            });
        } catch (e) {
            console.error('[applyGcbloStyle] addLayer failed', e);
        }
    }
    if (map.getSource('gcblo-labels') && !map.getLayer('gcblo-labels')) {
        try {
            map.addLayer({
                id: 'gcblo-labels',
                type: 'symbol',
                source: 'gcblo-labels',
                layout: {
                    'symbol-placement': 'line',
                    'text-field': ['coalesce', ['get', 'label_gcblo'], ''],
                    'text-size': 11,
                    'text-optional': true,
                    'text-keep-upright': true,
                    'symbol-spacing': 150,
                    'text-rotation-alignment': 'viewport',
                },
                paint: {
                    'text-color': '#111827',
                    'text-halo-color': '#f8fafc',
                    'text-halo-width': 1.2,
                },
            });
        } catch (e) {
            console.error('[applyGcbloStyle] addLayer labels failed', e);
        }
    }
    const hasBaseLayer = !!map.getLayer('gcblo-rosalyna-base');
    const hasOffsetLayer = !!map.getLayer('gcblo-rosalyna');
    if (!hasOffsetLayer) {
        console.warn("[applyGcbloStyle] layer gcblo-rosalyna manquante, skip");
        return;
    }
    if (!hasBaseLayer) {
        console.warn("[applyGcbloStyle] layer gcblo-rosalyna-base manquante");
    }
    // Visibilité : base toujours visible, offset visible si demandé
    if (hasBaseLayer) map.setLayoutProperty('gcblo-rosalyna-base', 'visibility', 'visible');
    map.setLayoutProperty('gcblo-rosalyna', 'visibility', mode ? 'visible' : 'visible');
    const baseColor = '#00faaf';
    if (!mode) {
        if (hasBaseLayer) {
            map.setPaintProperty('gcblo-rosalyna-base', 'line-color', baseColor);
            map.setPaintProperty('gcblo-rosalyna-base', 'line-width', 2);
            map.setPaintProperty('gcblo-rosalyna-base', 'line-offset', 0);
        }
        map.setPaintProperty('gcblo-rosalyna', 'line-color', baseColor);
        map.setPaintProperty('gcblo-rosalyna', 'line-width', 4);
        map.setPaintProperty('gcblo-rosalyna', 'line-offset', 0);
        return;
    }
    // Assure un offset alterné par groupe de câbles colinéaires
    ensureGcbloOverlapOffsets();
    const diameterValue = ['coalesce',
        ['to-number', ['get', 'diametre_num']],
        ['to-number', ['get', 'type_cable_capacite']],
        0
    ];
    // Debug stat diamètres pour vérifier les valeurs utilisées
    try {
        if (Array.isArray(gcbloFeatures) && gcbloFeatures.length) {
            const buckets: Record<string, number> = {};
            let min = Number.POSITIVE_INFINITY;
            let max = Number.NEGATIVE_INFINITY;
            gcbloFeatures.slice(0, 5000).forEach((f) => {
                const props: any = f?.properties || {};
                const val = Number(props.diametre_num ?? props.type_cable_capacite ?? 0);
                if (!Number.isFinite(val)) return;
                min = Math.min(min, val);
                max = Math.max(max, val);
                const key = String(val);
                buckets[key] = (buckets[key] || 0) + 1;
            });
            const top = Object.entries(buckets)
                .sort((a, b) => b[1] - a[1])
                .slice(0, 5);
            console.log("[applyGcbloStyle] diam stats", { min, max, top });
        }
    } catch (_) {
        /* ignore */
    }

    map.setPaintProperty('gcblo-rosalyna', 'line-color', [
        'interpolate', ['linear'], diameterValue,
        0, '#374151',    // Gris foncé
        6, '#ef4444',    // Rouge
        8, '#f97316',    // Orange
        10, '#fbbf24',   // Jaune/orangé
        12, '#1d4ed8',   // Bleu foncé (valeurs intermédiaires <24)
        14, '#22c55e',   // Vert pour 14
        24, '#1d4ed8',   // Bleu foncé
        36, '#fbbf24',   // Orange clair
        48, '#f97316',   // Orange
        72, '#f97316',   // Orange
        96, '#d1d5db',   // Gris clair
        144, '#ec4899',  // Rose
        288, '#22c55e'   // Vert clair
    ]);
    map.setPaintProperty('gcblo-rosalyna', 'line-width', [
        'interpolate', ['linear'], diameterValue,
        0, 2.8,
        12, 4.2,
        24, 5,
        48, 6.2,
        96, 7.8,
        144, 8.6
    ]);
    // couche base sans offset pour garder les extrémités jointives
    if (map.getLayer('gcblo-rosalyna-base')) {
        map.setPaintProperty('gcblo-rosalyna-base', 'line-color', [
            'interpolate', ['linear'], diameterValue,
            0, '#374151',
            6, '#ef4444',
            8, '#f97316',
            10, '#fbbf24',
            12, '#1d4ed8',
            14, '#22c55e',
            24, '#1d4ed8',
            36, '#fbbf24',
            48, '#f97316',
            72, '#f97316',
            96, '#d1d5db',
            144, '#ec4899',
            288, '#22c55e'
        ]);
        map.setPaintProperty('gcblo-rosalyna-base', 'line-width', 2);
        map.setPaintProperty('gcblo-rosalyna-base', 'line-offset', 0);
    }
    // Offset léger pour séparer visuellement les câbles superposés.
    map.setPaintProperty('gcblo-rosalyna', 'line-offset', [
        'interpolate', ['linear'], ['zoom'],
        10, ['*', 2, ['coalesce', ['to-number', ['get', 'offset_idx']], 0]],   // léger écart à zoom bas
        16, ['*', 5, ['coalesce', ['to-number', ['get', 'offset_idx']], 0]]    // plus d'écart en zoom rapproché
    ]);
    cablesByDiameter.value = true;
    console.log("[applyGcbloStyle] applied", { mode, offsets: true });
};

/*Mousetrap.bind("c", function (e: any) {


    e.preventDefault();

    clearMarqueurSource('marqueurs');

});*/

// Exemple d'utilisation
// requete_angle(A.geometry.coordinates[1], A.geometry.coordinates[0], B.geometry.coordinates[1], B.geometry.coordinates[0]);
function requete_angle(p1y: any, p1x: any, p2y: any, p2x: any) {
    const dy = p2y - p1y;
    const dx = Math.cos(Math.PI / 180 * p1y) * (p2x - p1x);
    let angle = toGrads(Math.atan2(dy, dx));
    if (angle < 0) {
        angle = angle + 400;
    }
    return Math.round(angle);
}
function toGrads(radians: any) {
    radians = radians * 180 / Math.PI;
    return radians * 200 / 180;
}


/** Enregistre les clics NRO (import différé pour éviter cycle de modules). */
export function registerNroTopologyHandlersFromMap() {
    void import("@/services/nro-topology.services").then((mod) => {
        mod.registerNroTopologyMapHandlers();
    });
}

function generateRandomCode(length: any) {
    let result = '';
    const characters = '0123456789abcdef';

    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters.charAt(randomIndex);
    }

    return result;
}
